(function () {
if (typeof window.StorefrontLayoutAPI === 'undefined') {
  window.StorefrontLayoutAPI = {};
}
if (typeof window.StorefrontLayoutContext === 'undefined') {
  window.StorefrontLayoutContext = {};
}
if(typeof window.StorefrontLayoutExtensions === 'undefined'){
  window.StorefrontLayoutExtensions = {};
}

StorefrontLayoutContext.ActionTypes = {
  ManageListItem: 'ManageListItem',
  AddToCollection: 'AddToCollection',
  CreateCollection: 'CreateCollection',
  EditCollection: 'EditCollection',
  SaveCollection: 'SaveCollection',
  ShareList: 'ShareList',
}

StorefrontLayoutContext.NotificationStatusTypes = {
  Success: 'success',
  Error: 'error',
  Warning: 'Warning',
  Info: 'info',
  Neutral: 'neutral',
  Toast: 'toast'
}

StorefrontLayoutContext.NotificationActionTypes = {
  AddedToWishlist: 'added-to-wishlist',
  AddToCollection: 'add-to-collection',
  AddedToCollection: 'added-to-collection',
  AddedToCart: 'added-to-cart'
}

StorefrontLayoutContext.StorefrontLayoutUrls = {
  List: '#swym-list',
  Collections: '#swym-collections',
  CollectionList: '#swym-list:'
}

StorefrontLayoutContext.NotificationIconType = {
  SuccessIcon: 'SuccessIcon',
  RemoveIcon: 'RemoveIcon'
}

StorefrontLayoutContext.LoaderViewType = {
  WishlistListItem: 'wishlist-list-item',
  CarouselListItem: 'carousel-list-item',
  CollectionImages: 'collection-view-images',
  SpinnerLoader: 'spinner-loader'
}

StorefrontLayoutContext.ShopifyProductData = {};
StorefrontLayoutContext.fromCache = true;

/**
 * Checks if the current user has permission to edit the given wishlist.
 * @param {Object} list - The wishlist to check.
 * @returns {boolean} - Returns true if the user can edit the list, otherwise false.
 */
StorefrontLayoutContext.checkUserCanEditList = (list) => {
  if(!list){
      window._swat?.utils.warn('list not exist to check list access');
    return false;
  }
  let isUserList = StorefrontLayoutContext.lists.find((userList)=> userList.lid === list.lid);
  if(isUserList){
    return true;
  }
  return false;
}

/**
 * Formats a given price based on the store's money formatting settings.
 * @param {number} value - The price value to format.
 * @returns {string} - The formatted price string.
 */
StorefrontLayoutContext.FormatPrice = (value) => {
  try {
    if (window.SwymOverrideFormatMoneyFn) {
      return window.SwymOverrideFormatMoneyFn(value);
    }
    if (window._swat.platform.formatMoney) {
      if (
          window._swat.platform.currentMoneyFormat &&
          window._swat.platform.currentMoneyFormat()
      ) {
        return window._swat.platform.formatMoney(
          value * 100,
          window._swat.platform.currentMoneyFormat()
        );
      }
    }
  } catch (err) {
    window._swat?.utils.error("Error formatting price - " + value + err);
  }
  const currency = window._swat.currency;
  return currency + window._swat.utils.padDecimal(value);
}

/**
 * Calculates the difference in hours between the current time and a given date-time string.
 * @param {number} hours - The threshold hours to compare.
 * @param {string} dateTimeString - The stored date-time string.
 * @returns {boolean} - Returns true if the time difference exceeds the given hours, otherwise false.
 */
StorefrontLayoutExtensions.calcDifferenceInHours = (hours, dateTimeString) => {
  try {
    if (!dateTimeString) {
      window._swat?.utils.warn("[WARNING] Date time string empty");
      return;
    }
    const storedDateTime = new Date(dateTimeString?.trim());
    const currentDateTime = new Date();

    const differenceInMs = Math.abs(currentDateTime - storedDateTime);
    const differenceInHours = differenceInMs / (1000 * 60 * 60);
    return differenceInHours > hours;
  } catch (error) {
    window._swat?.utils.warn("[Error/Warning] while performing health check", error);
    return false;
  }
}


/**
 * Checks if a given container has a scrollbar and applies/removes a CSS class accordingly.
 * @param {HTMLElement} container - The container element to check.
 */
StorefrontLayoutExtensions.checkContainerScrollbar = (container) => {
  try{
    if(!container){
      window._swat?.utils.warn("container not available for scrollbar check");
      return;
    }
    if (container.scrollHeight > container.clientHeight) {
      container.classList.add("swym-storefront-layout-container-has-scroll");
    } else {
      container.classList.remove("swym-storefront-layout-container-has-scroll");
    }
  }catch(error){
    window._swat?.utils.warn("invalid container for scrollbar check");
  }
}

/**
 * Defines action codes for various storefront layout events.
 */
StorefrontLayoutExtensions.InstrumentActionCodes = {
  StorefrontLayoutInitialized: 701,
  StorefrontLayoutOpened: 702,
  StorefrontLayoutClosed: 703,
  StorefrontLayoutUserLogIn: 704,
  StorefrontLayoutCollectionRendered: 705,
  StorefrontLayoutWishlistItemsRendered: 706,
  StorefrontLayoutVariantChanged: 707,
  StorefrontLayoutItemAddedToCart: 708,
  StorefrontLayoutItemAddedToList: 709,
  StorefrontLayoutItemRemovedFromList: 710,
  StorefrontLayoutCollectionCreated: 711,
  StorefrontLayoutCollectionOpened: 712,
  StorefrontLayoutCollectionRenamed: 713,
  StorefrontLayoutCollectionDeleted: 714,
  StorefrontLayoutCollectionGridViewOpened: 715
};

/**
 * Defines UTM terms for tracking user engagement and interactions.
 */
StorefrontLayoutExtensions.InstrumentUtmTerms = {
  StorefrontLayoutUiEngagement: "storefront_layout_ui_engagement",
  StorefrontLayoutCollectionInteractions: "storefront_layout_collection_interactions",
  StorefrontLayoutWishlistItemInteractions: "storefront_layout_item_interactions",
  StorefrontLayoutCartConversion: "storefront_layout_cart_conversion"
};

function handleLocationChange() {
  const url = new URL(window.location.href);
  const path = url.pathname;
  const lid = url.searchParams.get('hkey');

  if ((path.includes('swym-share-wishlist') || path.includes('swym-wishlist')) && lid) {
    const newUrl = `${window.location.pathname}${StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList}${lid}`;
    console.log('on location changes for share', newUrl);
    window.location.href = newUrl;
  }
}

// Listen for history changes
handleLocationChange();
window.addEventListener('popstate', handleLocationChange);
window.addEventListener('load', handleLocationChange);

/**
 * SwymWishlistCore Component
 *
 * This component serves as the base class for Swym Wishlist Storefront Layout, 
 * providing the core functionality shared across different layout implementations:
 * - Drawer
 * - Page Section
 * - Modal
 *
 * Key Responsibilities:
 * - Initializes the UI and sets up event listeners for wishlist interactions.
 * - Handles fetching and rendering of wishlist items and collections.
 * - Monitors hash changes to update the UI accordingly.
 * - Integrates with Swym's API for wishlist actions and notifications.
 * - Provides a structured foundation for extending different storefront layout types.
 *
 * The component can be extended by specific layout implementations such as:
 * - `SwymStorefrontLayoutAsDrawer`
 * - `SwymStorefrontLayoutAsPageSection`
 * - `SwymStorefrontLayoutAsModal`
 */
class SwymWishlistCore extends HTMLElement {
  constructor() {
    super();
    this.StorefrontLayoutListView = "grid"
    this.wishlist = null;
    this.collections = [];
    this.elements = {};
    this.initUi();
    this.initSwymCallbacks();
  }

  connectedCallback() {
    if(this.StorefrontLayoutListView === 'grid'){
       this.parentElement?.classList.add('swym-storefront-layout-item-as-grid'); 
    }
  }
  initUi(){
    this.setAttribute('id', 'swym-storefront-layout');
    window.addEventListener('hashchange', ()=>{
      this.checkForSwymDrawerHash();
    });

    document.addEventListener(StorefrontLayoutContext?.CustomEvents?.SwymWishlistFetched, () => {
      this.wishlist = StorefrontLayoutContext?.DefaultList;
      this.collections = StorefrontLayoutContext?.collections;
      this.checkForSwymDrawerHash();
    })

    StorefrontLayoutExtensions.Notification = document.querySelector('swym-storefront-layout-notification');
  }

  reRenderWishlistListUI() {
    this.reRenderUI();
    this.initElement();
    this.renderWishlistAndCollections();
    this.checkForSwymDrawerHash();
  }

  initElement(){

    StorefrontLayoutExtensions.SwymStorefrontLayout = document.querySelector('swym-storefront-layout #swym-storefront-layout');
    StorefrontLayoutExtensions.SwymStorefrontLayoutActions = document.querySelector('#swym-storefront-layout-actions') || document.querySelector('#swym-storefront-layout-actions-target-page');
    StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip = document.querySelector('#swym-storefront-layout-action-tooltip') || document.querySelector('#swym-storefront-layout-action-tooltip-target-page');
    StorefrontLayoutExtensions.SwymStorefrontLayoutDefaultListActionOptions = document.querySelector('#swym-storefront-layout-list-action-options');
      
    StorefrontLayoutExtensions.wishlistListComponent = document.querySelector('swym-storefront-layout-default-wishlist');
    StorefrontLayoutExtensions.collectionsCarouselComponent = document.querySelector('swym-storefront-layout-collection-carousel');
    StorefrontLayoutExtensions.collectionsListComponent = document.querySelector('swym-storefront-layout-collection-list');
    StorefrontLayoutExtensions.sectionContainerComponent = document.querySelector('#swym-storefront-layout-section-container');

  }

  loadStrings() {
    try {
      const RetailerStrings = window._swat?.retailerSettings?.Strings || {};
      const {
        ThemeAppStorefrontLayoutTitle,

        ThemeAppStorefrontLayoutAddToCartCTA,
        ThemeAppStorefrontLayoutAddedToCartCTA,
        ThemeAppStorefrontLayoutAddingToCartCTA,
        ThemeAppStorefrontLayoutSoldoutCTA,

        ThemeAppStorefrontLayoutLoginHeading,
        ThemeAppStorefrontLayoutLoginMessage,
        ThemeAppStorefrontLayoutLoginButtonCTA,
        ThemeAppStorefrontLayoutLoggedUserWelcomeMessage,

        ThemeAppStorefrontLayoutWishlistTitle,
        ThemeAppStorefrontLayoutWishlistInfo,
        ThemeAppStorefrontLayoutEmptyWishlistTitle,
        ThemeAppStorefrontLayoutEmptyWishlistDescription,
        ThemeAppStorefrontLayoutDeleteListCTA,

        ThemeAppStorefrontLayoutCollectionsTitle,
        ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription,
        ThemeAppStorefrontLayoutEmptyCollectionsTitle,
        ThemeAppStorefrontLayoutEmptyCollectionsDescription,

        ThemeAppStorefrontLayoutAddToCollectionsTitle,
        ThemeAppStorefrontLayoutAddToCollectionCTA,
        ThemeAppStorefrontLayoutCreateCollectionCTA,
        ThemeAppStorefrontLayoutSaveNewCollectionCTA,
        ThemeAppStorefrontLayoutRemoveItemCTA,
        ThemeAppStorefrontLayoutRenameCollectionCTA,
        ThemeAppStorefrontLayoutDeleteCollectionCTA,
        ThemeAppStorefrontLayoutShareCollectionCTA,
        ThemeAppStorefrontLayoutSaveCollectionCTA,
        ThemeAppStorefrontLayoutEditCollectionCTA,
        ThemeAppStorefrontLayoutShareCollectionTitle,
        ThemeAppStorefrontLayoutShareCollectionMessage,
        ThemeAppStorefrontLayoutSharedCollectionMessage,
        ThemeAppStorefrontLayoutUpdateCollectionTitle,

        ThemeAppStorefrontLayoutErrorMessageListNameRequired,
        ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char,
        ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist,

        ThemeAppStorefrontLayoutNotificationMessageItemSaved,
        ThemeAppStorefrontLayoutNotificationMessageItemRemoved,
        ThemeAppStorefrontLayoutNotificationMessageAddedToCart,
        ThemeAppStorefrontLayoutNotificationMessageAddedToCollection,
        ThemeAppStorefrontLayoutNotificationMessageCollectionSaved,
        ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted,
        ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated,
        ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable,
        ThemeAppStorefrontLayoutNotificationActionAddToCollection,
        ThemeAppStorefrontLayoutNotificationActionView,
        ThemeAppStorefrontLayoutNotificationActionViewCollection,
        ThemeAppStorefrontLayoutNotificationActionGoToCart,

        ThemeAppStorefrontLayoutTextItem,
        ThemeAppStorefrontLayoutTextItems
      } = RetailerStrings;

      StorefrontLayoutContext.Strings = {
        ...StorefrontLayoutContext.Strings,
        ...(ThemeAppStorefrontLayoutTitle ? { 'title': ThemeAppStorefrontLayoutTitle } : {}),

        ...(ThemeAppStorefrontLayoutAddToCartCTA ? { 'addToCart': ThemeAppStorefrontLayoutAddToCartCTA } : {}),
        ...(ThemeAppStorefrontLayoutAddedToCartCTA ? { 'addedToCart': ThemeAppStorefrontLayoutAddedToCartCTA } : {}),
        ...(ThemeAppStorefrontLayoutAddingToCartCTA ? { 'addingToCart': ThemeAppStorefrontLayoutAddingToCartCTA } : {}),
        ...(ThemeAppStorefrontLayoutSoldoutCTA ? { 'soldOut': ThemeAppStorefrontLayoutSoldoutCTA } : {}),

        ...(ThemeAppStorefrontLayoutLoginHeading ? { 'loginHeading': ThemeAppStorefrontLayoutLoginHeading } : {}),
        ...(ThemeAppStorefrontLayoutLoginMessage ? { 'loginText': ThemeAppStorefrontLayoutLoginMessage } : {}),
        ...(ThemeAppStorefrontLayoutLoginButtonCTA ? { 'loginButtonText': ThemeAppStorefrontLayoutLoginButtonCTA } : {}),
        ...(ThemeAppStorefrontLayoutLoggedUserWelcomeMessage ? { 'loggedUserWelcomeMessage': ThemeAppStorefrontLayoutLoggedUserWelcomeMessage } : {}),

        ...(ThemeAppStorefrontLayoutWishlistTitle ? { 'wishlistTitle': ThemeAppStorefrontLayoutWishlistTitle } : {}),
        ...(ThemeAppStorefrontLayoutWishlistInfo ? { 'wishlistInfo': ThemeAppStorefrontLayoutWishlistInfo } : {}),
        ...(ThemeAppStorefrontLayoutEmptyWishlistTitle ? { 'emptyWishlistTitle': ThemeAppStorefrontLayoutEmptyWishlistTitle } : {}),
        ...(ThemeAppStorefrontLayoutEmptyWishlistDescription ? { 'emptyWishlistDescription': ThemeAppStorefrontLayoutEmptyWishlistDescription } : {}),

        ...(ThemeAppStorefrontLayoutDeleteListCTA ? { 'deleteListCta': ThemeAppStorefrontLayoutDeleteListCTA } : {}),

        ...(ThemeAppStorefrontLayoutCollectionsTitle ? { 'collectionTitle': ThemeAppStorefrontLayoutCollectionsTitle } : {}),
        ...(ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription ? { 'emptyCarouselCollectionText': ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription } : {}),
        ...(ThemeAppStorefrontLayoutEmptyCollectionsTitle ? { 'emptyCollectionText': ThemeAppStorefrontLayoutEmptyCollectionsTitle } : {}),
        ...(ThemeAppStorefrontLayoutEmptyCollectionsDescription ? { 'emptyCollectionDescription': ThemeAppStorefrontLayoutEmptyCollectionsDescription } : {}),

        ...(ThemeAppStorefrontLayoutAddToCollectionsTitle ? { 'addToCollectionTitle': ThemeAppStorefrontLayoutAddToCollectionsTitle } : {}),
        ...(ThemeAppStorefrontLayoutAddToCollectionCTA ? { 'addToCollectionCta': ThemeAppStorefrontLayoutAddToCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutCreateCollectionCTA ? { 'createCollectionCta': ThemeAppStorefrontLayoutCreateCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutSaveNewCollectionCTA ? { 'saveNewCollectionCta': ThemeAppStorefrontLayoutSaveNewCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutRemoveItemCTA ? { 'removeItemCta': ThemeAppStorefrontLayoutRemoveItemCTA } : {}),
        ...(ThemeAppStorefrontLayoutRenameCollectionCTA ? { 'renameCollectionCta': ThemeAppStorefrontLayoutRenameCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutDeleteCollectionCTA ? { 'deleteCollectionCta': ThemeAppStorefrontLayoutDeleteCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutShareCollectionCTA ? { 'shareCollectionCta': ThemeAppStorefrontLayoutShareCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutSaveCollectionCTA ? { 'saveCollectionCta': ThemeAppStorefrontLayoutSaveCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutEditCollectionCTA ? { 'editCollectionCta': ThemeAppStorefrontLayoutEditCollectionCTA } : {}),
        ...(ThemeAppStorefrontLayoutShareCollectionTitle ? { 'shareCollectionTitle': ThemeAppStorefrontLayoutShareCollectionTitle } : {}),
        ...(ThemeAppStorefrontLayoutShareCollectionMessage ? { 'shareCollectionMessage': ThemeAppStorefrontLayoutShareCollectionMessage } : {}),
        ...(ThemeAppStorefrontLayoutSharedCollectionMessage ? { 'sharedCollectionMessage': ThemeAppStorefrontLayoutSharedCollectionMessage } : {}),
        ...(ThemeAppStorefrontLayoutUpdateCollectionTitle ? { 'updateCollectionTitle': ThemeAppStorefrontLayoutUpdateCollectionTitle } : {}),

        ...(ThemeAppStorefrontLayoutErrorMessageListNameRequired ? { 'errorMessageListNameRequired': ThemeAppStorefrontLayoutErrorMessageListNameRequired } : {}),
        ...(ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char ? { 'errorMessageListNameRequire3Char': ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char } : {}),
        ...(ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist ? { 'errorMessageListNameAlreadyExist': ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist } : {}),

        ...(ThemeAppStorefrontLayoutNotificationMessageItemSaved ? { 'notificationMessageItemSaved': ThemeAppStorefrontLayoutNotificationMessageItemSaved } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageItemRemoved ? { 'notificationMessageItemRemoved': ThemeAppStorefrontLayoutNotificationMessageItemRemoved } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageAddedToCart ? { 'notificationMessageAddedToCart': ThemeAppStorefrontLayoutNotificationMessageAddedToCart } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageAddedToCollection ? { 'notificationMessageAddedToCollection': ThemeAppStorefrontLayoutNotificationMessageAddedToCollection } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageCollectionSaved ? { 'notificationMessageCollectionSaved': ThemeAppStorefrontLayoutNotificationMessageCollectionSaved } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted ? { 'notificationMessageCollectionDeleted': ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated ? { 'notificationMessageCollectionUpdated': ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated } : {}),
        ...(ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable ? { 'notificationMessageCollectionUnavailable': ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable } : {}),
        ...(ThemeAppStorefrontLayoutNotificationActionAddToCollection ? { 'notificationActionAddToCollection': ThemeAppStorefrontLayoutNotificationActionAddToCollection } : {}),
        ...(ThemeAppStorefrontLayoutNotificationActionView ? { 'notificationActionView': ThemeAppStorefrontLayoutNotificationActionView } : {}),
        ...(ThemeAppStorefrontLayoutNotificationActionViewCollection ? { 'notificationActionViewCollection': ThemeAppStorefrontLayoutNotificationActionViewCollection } : {}),
        ...(ThemeAppStorefrontLayoutNotificationActionGoToCart ? { 'notificationActionGoToCart': ThemeAppStorefrontLayoutNotificationActionGoToCart } : {}),

        ...(ThemeAppStorefrontLayoutTextItem ? { 'item': ThemeAppStorefrontLayoutTextItem } : {}),
        ...(ThemeAppStorefrontLayoutTextItems ? { 'items': ThemeAppStorefrontLayoutTextItems } : {}),
      }
      this.reRenderWishlistListUI();
    } catch (error) {
      window._swat?.utils.error(error);
    }
  }

  initSwymCallbacks() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallbackFn.bind(this));
  }

  swymCallbackFn(swat) {

    swat.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutInitialized, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });

    swat.evtLayer.addEventListener(swat.JSEvents.StringsLoaded, (event) => {
      this.loadStrings();
    });

    swat.evtLayer.addEventListener(swat.JSEvents.customerInfoRefreshed, ()=>{
      this.refreshList();
    })

    this.attachSwymEventListeners(swat);
    if (!this.wishlist || !this.collections) {
      this.wishlist = StorefrontLayoutContext.DefaultList;
      this.collections = StorefrontLayoutContext.collections;
    }
    if (!this.wishlist || !this.collections) {
      this.refreshList();
    }
  }

  async checkForSwymDrawerHash() {
    const { StorefrontLayoutType, StorefrontLayoutAsSectionPageURL } = StorefrontLayoutContext.Settings;
    const currentHash = window.location.hash;

    const openWishlistPage = () => {
        if (StorefrontLayoutType === 'as-drawer' || StorefrontLayoutType === 'as-modal') {
            StorefrontLayoutExtensions.SwymStorefrontLayout?.open();
        } else if (StorefrontLayoutType === 'as-section' && window.location.pathname !== StorefrontLayoutAsSectionPageURL) {
          const locale = window.Shopify.routes.root
          const formattedLocale = locale === '/' ? '' : locale.replace(/\/$/, '')
          window.location = `${window.location.origin}${formattedLocale}${StorefrontLayoutAsSectionPageURL}${window.location.hash}`;
        }
    };

    if (currentHash === StorefrontLayoutContext.StorefrontLayoutUrls?.List) {
      StorefrontLayoutExtensions.collectionsListComponent?.closeCollectinListView();
        openWishlistPage();
    } else if (currentHash.startsWith(StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList)) {
        const collectionId = currentHash.slice(StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList.length);

        if (collectionId && StorefrontLayoutContext.collections) {
            const selectedCollection = StorefrontLayoutContext.collections?.find(collection => collection.lid === collectionId);

            if (selectedCollection) {
              StorefrontLayoutExtensions.collectionsListComponent?.setData({
                list: selectedCollection,
                collections: StorefrontLayoutContext.collections
              });
              StorefrontLayoutExtensions.collectionsListComponent?.openCollectionListView();
            } else {
              try{
                StorefrontLayoutExtensions.collectionsListComponent?.openCollectionListView();
                const sharedListDetails = await StorefrontLayoutAPI?.SwymWLAsyncApis?.fetchListDetails(collectionId);
                if(sharedListDetails?.list){
                  StorefrontLayoutExtensions.collectionsListComponent?.setData({
                    list: sharedListDetails.list,
                    collections: StorefrontLayoutContext.collections
                  });
                  StorefrontLayoutExtensions.collectionsListComponent?.openCollectionListView();
                }else{
                  throw 'Collection Not Available';
                }
              }catch(e){
                StorefrontLayoutExtensions.collectionsListComponent?.closeCollectinListView();
                StorefrontLayoutExtensions.Notification?.setMessage({
                  message: StorefrontLayoutContext.Strings?.notificationMessageCollectionUnavailable,
                  status: StorefrontLayoutContext.NotificationStatusTypes?.Error,
                  duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration
                });
                window._swat?.utils.error(`Collection detail not found for ID: ${collectionId}. It may have been deleted or is unavailable.`,e);
              }
            }

            openWishlistPage();
        }
    }
  }


  attachSwymEventListeners(swat) {
    swat.evtLayer.addEventListener('sw:addedtowishlist', (event) => {
      const isMultiListEnabled = swat.retailerSettings?.Wishlist?.EnableCollections;
      this.refreshList(swat);

      let image = event?.detail?.d?.iu || null;
      let { epi, empi } = event?.detail?.d || {};
      let product = event?.detail.d;
      
      swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutItemAddedToList, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutWishlistItemInteractions, epi, empi });

        if(StorefrontLayoutContext.swat?.ui?.uiRef?.settings?.UI?.WishlistShowNotification){
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: StorefrontLayoutContext.Strings?.notificationMessageItemSaved,
            status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
            actionType: StorefrontLayoutContext.NotificationActionTypes.AddedToWishlist,
            duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
            product,
            image
          },{
            showImage: true,
            showProgress: true
          });
    
          setTimeout(()=>{
            if(StorefrontLayoutExtensions.Notification.notificationData.actionType === StorefrontLayoutContext.NotificationActionTypes.AddedToWishlist){
              StorefrontLayoutExtensions.Notification?.setMessage({
                status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
                actionType: StorefrontLayoutContext.NotificationActionTypes.AddedToWishlist,
                duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
                product,
                image,
                action: {
                    label: (!isMultiListEnabled && StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection)? StorefrontLayoutContext.Strings?.notificationActionAddToCollection:  StorefrontLayoutContext.Strings?.notificationActionView,
                    onClick: () => {
                      if(!isMultiListEnabled && StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection){
                        StorefrontLayoutExtensions.SwymStorefrontLayoutPageActions?.setData({
                          listId: this.wishlist.lid,
                          list: this.wishlist,
                          item: product,
                          collections: this.collections,
                          actionType: StorefrontLayoutContext.ActionTypes.AddToCollection
                        });
                        StorefrontLayoutExtensions.SwymStorefrontLayoutPageActions?.openDrawer();
                      }else{
                        window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.List; 
                      }
                    }
                }
              },{
                showImage: true,
                showActionButton: true,
                showTitle: true
              });
            }
          },3000);
        }

    });

    swat.evtLayer.addEventListener('sw:removedfromwishlist', (event) => {

      let image = event?.detail?.d?.iu || null;
      let { epi, empi } = event?.detail?.d || {};

      if( epi && empi){
         this.refreshList();
         swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutItemRemovedFromList, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutWishlistItemInteractions, epi, empi }); 
      }

      StorefrontLayoutExtensions.Notification?.setMessage({
        message: StorefrontLayoutContext.Strings?.notificationMessageItemRemoved,
        status: StorefrontLayoutContext.NotificationStatusTypes?.Toast,
        duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
        image
      });

    });
  }

  refreshList() {
    this.fetchWishlist();
  }

  async fetchWishlist() {
    try {
      let lists = await StorefrontLayoutAPI?.SwymWLAsyncApis?.updateList();
      lists = lists.sort((a, b) => b.cts - a.cts);
      
      this.wishlist = StorefrontLayoutContext.DefaultList;
      this.collections = StorefrontLayoutContext.collections;

      if (this.wishlist && this.wishlist.listcontents) {
        this.wishlist.listcontents = this.wishlist.listcontents.sort((a, b) => b.cts - a.cts);
      }
      
      this.collections.forEach((collection) => {
        if (collection.listcontents) {
          collection.listcontents = collection.listcontents.sort((a, b) => b.cts - a.cts);
        }
      });

      this.renderWishlistAndCollections();
    } catch (error) {
      window._swat?.utils.error('Failed to fetch swym wishlist', error);
    }
  }

  renderWishlistAndCollections() {
    if ( this.wishlist || this.collections) {
      
      if(window.location.hash.startsWith(StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList)){
        const collectionId = window.location.hash.slice(StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList.length);
        if(StorefrontLayoutExtensions.collectionsListComponent && this.collections){
          let selectedCollection = this.collections.find((collection)=> collection.lid === collectionId);
          StorefrontLayoutExtensions.collectionsListComponent?.setData({ list: selectedCollection, collections: this.collections })
        }
      }

      StorefrontLayoutExtensions.wishlistListComponent?.setData({ wishlist: this.wishlist, collections: this.collections });

      if (StorefrontLayoutExtensions.collectionsCarouselComponent && this.collections) {
        StorefrontLayoutExtensions.collectionsCarouselComponent?.setData({ collections: this.collections });
      }

    } 

    if(StorefrontLayoutExtensions.SwymStorefrontLayoutDefaultListActionOptions){
       StorefrontLayoutExtensions.SwymStorefrontLayoutDefaultListActionOptions?.setData({
        listId: this.wishlist?.lid,
        list: this.wishlist,
        collections: this.collections,
        //actionType: StorefrontLayoutContext.ActionTypes.EditCollection
      }); 
    }
    
  }

}

/**
 * SwymStorefrontLayoutAsModal
 * 
 * This class extends SwymWishlistCore to render a modal-based storefront layout for the Swym wishlist.
 * It manages UI rendering, event listeners, and open/close interactions.
 * 
 * Features:
 * - Displays a modal layout for wishlist functionality.
 * - Supports collection carousel based on StorefrontLayoutContext settings.
 * - Provides a close button and backdrop click handling to close the modal.
 * - Tracks UI engagement using Swym's instrumentation.
 * 
 * Methods:
 * - renderUI(): Generates the modal's HTML structure.
 * - initUIElement(): Initializes UI elements and event listeners.
 * - attachDrawerEventListner(): Binds click events to close the modal.
 * - open(): Opens the modal and updates the UI state.
 * - close(): Closes the modal, removes body scroll lock, and updates history state.
 * - reRenderUI(): Re-renders the UI while preserving the open state.
 * 
 * Usage:
 * <swym-storefront-layout-as-modal></swym-storefront-layout-as-modal>
 */
class SwymStorefrontLayoutAsModal extends SwymWishlistCore {
  constructor() {
    super();
    this.renderUI();
  }

  renderUI() {
    this.innerHTML = `
          <div id="swym-storefront-layout-container" class="swym-storefront-layout-drawer swym-storefront-layout-hide-view">
          <div class="swym-storefront-layout-backdrop"></div>
          <div class="swym-storefront-layout-layout">
            <button id="swym-storefront-layout-close-drawer-button" class="swym-storefront-layout-close-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="white"/>
                <path d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z" fill="#4A4A4A"/>
              </svg>
            </button>
            <div class="swym-storefront-layout-header">
              <swym-storefront-layout-title></swym-storefront-layout-title>
              ${!StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-list-options id="swym-storefront-layout-list-action-options"></swym-storefront-layout-list-options>`:''}
            </div>
            <div class="swym-storefront-layout-container swym-storefront-layout-scrollable">
              ${StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-collection-carousel></swym-storefront-layout-collection-carousel>` : ''}
              <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
            </div>
            <div class="swym-storefront-layout-empty-container"></div>
            <swym-storefront-layout-collection-list id="swym-storefront-layout-collection-list"></swym-storefront-layout-collection-list>
            <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
          </div>
        </div>
    `

    this.initUIElement();
  }

  initUIElement() {
    this.elements = {
      drawer: this.querySelector('.swym-storefront-layout-drawer'),
      drawerCloseButton: this.querySelector('#swym-storefront-layout-close-drawer-button'),
      drawerbackdrop: this.querySelector('.swym-storefront-layout-backdrop'),
      collectionList: this.querySelector('#swym-storefront-layout-collection-list'),
    }


    this.attachDrawerEventListner();

  }


  attachDrawerEventListner() {
    this.elements.drawerCloseButton.addEventListener('click', this.close.bind(this));
    this.elements.drawerbackdrop.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.isOpen = true;
    if (this.elements && this.elements.drawer) {
      this.elements.drawer.classList.remove('swym-storefront-layout-hide-view');
      document.body.classList.add('no-scroll');
      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutOpened, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
    }
  }

  close() {
    this.isOpen = false;
    if (this.elements && this.elements.drawer) {
      this.elements.drawer.classList.add('swym-storefront-layout-hide-view');
      document.body.classList.remove('no-scroll');
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutClosed, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
    }
  }

  reRenderUI() {
    this.renderUI();
    if (this.isOpen) {
      this.open();
    }
  }

}

/**
 * SwymStorefrontLayoutAsSection
 * 
 * This class extends SwymWishlistCore to render a storefront wishlist layout as a section within a specified container.
 * It dynamically injects the wishlist UI into the provided container element.
 * 
 * Features:
 * - Renders the wishlist section inside a container specified by the `container-id` attribute.
 * - Supports collection carousel based on StorefrontLayoutContext settings.
 * - Displays wishlist items and user login UI.
 * - Handles rendering errors gracefully and logs warnings if an invalid container ID is provided.
 * 
 * Methods:
 * - renderUI(): Generates the section-based wishlist UI and injects it into the specified container.
 * - reRenderUI(): Re-renders the UI to reflect any updates.
 * 
 * Usage:
 * <swym-storefront-layout-as-section container-id="your-container-id"></swym-storefront-layout-as-section>
 */

class SwymStorefrontLayoutAsSection extends SwymWishlistCore {
  constructor() {
    super();
    this.containerId = this.getAttribute('container-id');
    this.renderUI();
  }

  renderUI() {
    let { StorefrontLayoutType } = StorefrontLayoutContext.Settings;
    if(StorefrontLayoutType === 'as-section'){
      this.listContainerToRender = null;
      try {
        this.listContainerToRender = document.getElementById(this.containerId);

        this.listContainerToRender.innerHTML = `
        <div id="swym-storefront-layout-container">
          <div id="swym-storefront-layout-section-container" class="swym-storefront-layout-layout">
            <div class="swym-storefront-layout-header">
              <swym-storefront-layout-title></swym-storefront-layout-title>
              <swym-storefront-layout-login-user showUser="false"></swym-storefront-layout-login-user>
              ${!StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-list-options id="swym-storefront-layout-list-action-options"></swym-storefront-layout-list-options>`:''}
            </div>
            <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
            <div class="swym-storefront-layout-container">
              ${StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-collection-carousel></swym-storefront-layout-collection-carousel>` : ''}
              <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
            </div>
            <div class="swym-storefront-layout-empty-container"></div>
          </div>
          <swym-storefront-layout-collection-list id="swym-storefront-layout-collection-list"></swym-storefront-layout-collection-list>
        </div>
        `

        this.listContainerToRender.classList.add('swym-storefront-layout-root-component');

      } catch (error) {
        window._swat?.utils.warn('Invalid List Container Selector ', this.containerId);
      }
    }
  }

  reRenderUI() {
    this.renderUI();
  }

}

/**
 * SwymStorefrontLayoutAsDrawer
 * 
 * This class extends SwymWishlistCore to implement a drawer-style storefront wishlist layout.
 * It provides an interactive UI for users to view and manage their wishlist within a side drawer.
 * 
 * Features:
 * - Renders a wishlist drawer that slides in/out based on user interaction.
 * - Supports collection carousel display based on StorefrontLayoutContext settings.
 * - Includes login UI for authentication-related actions.
 * - Implements event listeners for closing the drawer via a close button or backdrop click.
 * - Triggers instrumentation events for UI engagement tracking.
 * 
 * Methods:
 * - renderUI(): Generates the wishlist drawer UI and injects it into the component.
 * - initUIElement(): Caches DOM elements required for interactions.
 * - attachDrawerEventListner(): Attaches event listeners for closing the drawer.
 * - open(): Opens the drawer and prevents background scrolling.
 * - close(): Closes the drawer, restores scrolling, and updates browser history.
 * - reRenderUI(): Re-renders the UI and retains the open state if applicable.
 * 
 * Usage:
 * <swym-storefront-layout-as-drawer></swym-storefront-layout-as-drawer>
 */
class SwymStorefrontLayoutAsDrawer extends SwymWishlistCore {
  constructor() {
    super();
    this.renderUI();
  }

  renderUI() {
    this.innerHTML = `
          <div id="swym-storefront-layout-container" role="region" aria-labelledby="side-drawer" class="swym-storefront-layout-drawer swym-storefront-layout-hide-view  swym-storefront-layout-drawer-position-${StorefrontLayoutContext.Settings?.StorefrontLayoutDrawerPosition}">
          <div class="swym-storefront-layout-backdrop"></div>
          <div class="swym-storefront-layout-layout">
            <button id="swym-storefront-layout-close-drawer-button" class="swym-storefront-layout-close-button">
              <svg data-v-bfb713a3="" data-v-e057eb37="" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="base-icon close-icon" aria-hidden="true"><path d="m10.536 1.5-9 9M1.536 1.5l9 9" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
            <div class="swym-storefront-layout-header">
              <swym-storefront-layout-title></swym-storefront-layout-title>
              <swym-storefront-layout-login-user showUser="false"></swym-storefront-layout-login-user>
              ${!StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-list-options id="swym-storefront-layout-list-action-options"></swym-storefront-layout-list-options>`:''}
            </div>
            <div class="swym-storefront-layout-container swym-storefront-layout-scrollable">
              ${StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `<swym-storefront-layout-collection-carousel></swym-storefront-layout-collection-carousel>` : ''}
              <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
            </div>
            <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
            <swym-storefront-layout-collection-list id="swym-storefront-layout-collection-list"></swym-storefront-layout-collection-list>
            <swym-storefront-layout-actions id="swym-storefront-layout-actions"></swym-storefront-layout-actions>
          </div>
        </div>
    `
    this.initUIElement();
  }

  initUIElement() {
    this.elements = {
      drawer: this.querySelector('.swym-storefront-layout-drawer'),
      drawerCloseButton: this.querySelector('#swym-storefront-layout-close-drawer-button'),
      drawerbackdrop: this.querySelector('.swym-storefront-layout-backdrop'),
      collectionList: this.querySelector('#swym-storefront-layout-collection-list')
    }
    this.attachDrawerEventListner();
  }

  attachDrawerEventListner() {
    this.elements.drawerCloseButton.addEventListener('click', this.close.bind(this));
    this.elements.drawerbackdrop.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.isOpen = true;
    if (this.elements && this.elements.drawer) {
      this.elements.drawer.classList.remove('swym-storefront-layout-hide-view');
      document.body.classList.add('no-scroll');
      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutOpened, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
    }
  }

  close() {
    this.isOpen = false;
    if (this.elements && this.elements.drawer) {
      this.elements.drawer.classList.add('swym-storefront-layout-hide-view');
      document.body.classList.remove('no-scroll');
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutClosed, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
    }
  }

  reRenderUI() {
    this.renderUI();
    if (this.isOpen) {
      this.open();
    }
  }

}

/**
 * SwymStorefrontLayoutCollectionCarousel
 * 
 * This custom Web Component is responsible for rendering a carousel of collection lists 
 * within the storefront layout. It dynamically updates based on the provided collection 
 * data and offers smooth scrolling functionality with navigation buttons.
 * 
 * Features:
 * - Dynamically renders collections with images and item counts.
 * - Implements smooth scrolling with previous/next buttons.
 * - Updates button visibility based on scroll position.
 * - Tracks user interactions using Swym's instrumentation.
 * - Provides an action button for each collection with a tooltip menu.
 * - Supports localization via `StorefrontLayoutContext.Strings`.
 * 
 * Usage:
 * - Call `setData({ collections })` to populate the carousel with collection data.
 * 
 * Dependencies:
 * - `window.StorefrontLayoutContext` for localized strings and configurations.
 * - `window._swat?.instrumentV3` for tracking user interactions.
 * - `StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip` for managing action tooltips.
 * 
 */
class SwymStorefrontLayoutCollectionCarousel extends HTMLElement {
  constructor() {
    super();
    this.collections = [];
    this.renderUI();
    this.elements = {
      title: this.querySelector('.swym-storefront-layout-collection-carousel-title'),
      carouselContainer: this.querySelector('.swym-storefront-layout-carousel-container'),
      carousel: this.querySelector('#swym-storefront-layout-collection-carousel-items-container'),
      carouselPrevButton: this.querySelector('.swym-storefront-layout-carousel-prev-btn'),
      carouselNextButton: this.querySelector('.swym-storefront-layout-carousel-next-btn')
    }
    this.attachEventListner();
  }

  setData({ collections }) {
    this.collections = collections;
    this.renderCollections();
  }

  renderUI() {
    this.innerHTML = `
    <div class="swym-storefront-layout-collection-carousel-container">
      <div class="swym-storefront-layout-collection-carousel-title">${window.StorefrontLayoutContext.Strings?.collectionTitle}</div>
      <div class="swym-storefront-layout-carousel-container">
        <button class="swym-storefront-layout-carousel-btn swym-storefront-layout-carousel-prev-btn" aria-label="Scroll Left">
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="swym-storefront-layout-scroll-button-icon" aria-hidden="true"><path d="m13.333 8 8 8-8 8" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <div id="swym-storefront-layout-collection-carousel-items-container" class="swym-storefront-layout-carousel swym-storefront-layout-scrollable">
          <swym-storefront-layout-loader loading="true" loadertype="${StorefrontLayoutContext.LoaderViewType.CarouselListItem}" width="100%" height="100px"></swym-storefront-layout-loader>
        </div>
        <button class="swym-storefront-layout-carousel-btn swym-storefront-layout-carousel-next-btn" aria-label="Scroll Right">
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="swym-storefront-layout-scroll-button-icon" aria-hidden="true"><path d="m13.333 8 8 8-8 8" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
      </div>
    </div>
    `
  }

  attachEventListner() {

    this.elements.carouselPrevButton.addEventListener("click", () => {
      this.elements.carousel.scrollBy({
        left: -320,
        behavior: "smooth",
      });
    });

    this.elements.carouselNextButton.addEventListener("click", () => {
      this.elements.carousel.scrollBy({
        left: 320,
        behavior: "smooth",
      });
    });

    this.elements.carousel.addEventListener("scroll", () => this.updateCarouselButtonVisibility());

  }

  renderCollections() {
    const collectionsContainer = this.querySelector('#swym-storefront-layout-collection-carousel-items-container');
    if (collectionsContainer) {

      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutCollectionRendered, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });

      if (this.collections && this.collections.length) {
        this.elements.carouselContainer.classList.add('swym-storefront-layout-has-items');
        collectionsContainer.innerHTML = this.collections
          .map(
            (collection) => {
              let { lname, listcontents, lid } = collection;

              const listImagesHtml = Array.from({ length: 3 })
                .map((_, i) => {
                  let item = listcontents[i];
                  return `
                  <div class="${i === 0 ? 'swym-storefront-layout-collection-grid-item-primary-image' : 'swym-storefront-layout-collection-grid-item-secondary-image'} ">
                    ${item?.iu ? `<img src="${item ? item.iu : null}" class="swym-storefront-layout-collection-grid-item-image" />` : `<div class="swym-storefront-layout-collection-grid-item-image" ></div>`}
                  </div>
                `;
                })
                .join("");

              const count = listcontents.length;

              return `
              <div class="swym-storefront-layout-collection-grid-item" data-lid="${lid}">
                <div class="swym-storefront-layout-collection-grid-item-image-container">
                  ${listImagesHtml}
                </div>
                <div class="swym-storefront-layout-collection-grid-item-info-container">
                  <div class="swym-storefront-layout-collection-grid-item-name">${lname}</div>
                  <div class="swym-storefront-layout-collection-grid-item-count">${count} ${count === 1 ? 'item' : 'items'}</div>
                </div>
                <div id="swym-storefront-layout-collection-grid-item-option-button" class="swym-storefront-layout-collection-grid-item-option-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="none">
                    <circle cx="1.5" cy="1.50014" r="1.5" fill="#B1B7C3"/>
                    <circle cx="1.5" cy="6.50014" r="1.5" fill="#B1B7C3"/>
                    <circle cx="1.5" cy="11.5001" r="1.5" fill="#B1B7C3"/>
                  </svg>
                </div>
              </div>
            `
            }
          )
          .join('');
        this.updateCarouselButtonVisibility();
        this.attachEventListnerToCollectionGrid();
      } else {
        this.elements.carouselContainer.classList.remove('swym-storefront-layout-has-items');
        collectionsContainer.innerHTML = `
          <div class="swym-storefront-layout-collection-empty">${StorefrontLayoutContext.Strings?.emptyCarouselCollectionText}</div>
        `;
      }

      let collectionCount = this.collections.length;
      if(this.elements.title){
        this.elements.title.innerHTML = `${window.StorefrontLayoutContext.Strings?.collectionTitle} ${collectionCount?`(${collectionCount})`:''}`;
      }
    }
  }


  updateCarouselButtonVisibility() {
    const scrollLeft = this.elements.carousel.scrollLeft;
    const maxScrollLeft = this.elements.carousel.scrollWidth - this.elements.carousel.clientWidth;

    this.elements.carouselPrevButton.style.display = scrollLeft > 0 ? "flex" : "none";
    this.elements.carouselNextButton.style.display = scrollLeft < maxScrollLeft ? "flex" : "none";
  }

  attachEventListnerToCollectionGrid() {
    this.collections.forEach((collection) => {
      const collectionItem = this.elements.carousel.querySelector(
        `[data-lid="${collection.lid}"]`
      );
      collectionItem?.addEventListener("click", (event) => {
        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutCollectionOpened, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
        window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList + collection.lid;
      });

      let collectionItemActionButton =  collectionItem.querySelector('#swym-storefront-layout-collection-grid-item-option-button');
      collectionItemActionButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
          StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.closeTooltip();
        }else{
          StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.setData({
            listId: collection.lid,
            list: collection,
            collections: this.collections,
            actionType: StorefrontLayoutContext.ActionTypes.EditCollection
          });
          StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
        }
      })

    })
  }
}

/**
 * SwymStorefrontLayoutWishlistItem
 *
 * This custom web component represents an item in the Swym Storefront Layout Wishlist.
 * It dynamically renders product details, pricing, and actions such as adding to cart
 * or managing wishlist options. It also handles variant selection and user interactions
 * based on the store's configuration settings.
 *
 * Key Features:
 * - Displays product title, image, price, and compare-at price.
 * - Supports multiple product variants and allows selection.
 * - Handles "Add to Cart" functionality with visual feedback.
 * - Manages user interactions for wishlist options and collections.
 * - Ensures compatibility with store localization settings.
 *
 * Dependencies:
 * - StorefrontLayoutContext: Provides store settings, strings, and utilities.
 * - StorefrontLayoutExtensions: Handles tooltips and notifications.
 * - _swat.platform: Manages cart operations.
 *
 * Usage:
 * This component should be used within the Swym Storefront Layout to display 
 * wishlist items effectively while maintaining a seamless user experience.
 */
class SwymStorefrontLayoutWishlistItem extends HTMLElement{
  constructor() {
    super();
    this.item = null;
    this.list = null;
    this.selectedVariant = null;
    this.collections = null;
    this.viewType = 'Grid';
  }

  setData({ item, list, collections }) {
    this.item = item;
    this.list = list;
    this.collections = collections;
    this.selectedVariant = this.getSelectedVariant(item);
    this.dataset.epi = this.selectedVariant?.id || item.epi;
    this.dataset.empi = this.item?.empi;
    this.dataset.du = this.item?.du;
    this.renderItem();
  }

  getSelectedVariant(item) {
    const selectedVariantId = item.cprops?.selectedVariantId || item.epi;
    let selectedVariant = item.productData?.variants?.find((variant) => variant.id === selectedVariantId) || item.productData?.variants.find((variant) => variant.available) || item.productData?.variants[0];
    return selectedVariant;
  }

  getProductImage() {
    return this.selectedVariant?.featured_image?.src || this.item?.productData?.featured_image || this.item?.iu;
  }

  getFormattedPrice() {
    let price = ( this.selectedVariant?.price || this.item?.productData?.price ) / 100;
    return price?StorefrontLayoutContext.FormatPrice(price):'';
  }

  getFormattedComparePrice() {
    if(this.selectedVariant?.compare_at_price === this.selectedVariant?.price){
      return null;
    }
    let comparePrice = ( this.selectedVariant?.compare_at_price || this.item?.productData?.compare_at_price ) / 100;
    return comparePrice? StorefrontLayoutContext.FormatPrice(comparePrice): '';
  }

  getButtonState() {
    const isInCart = _swat.platform.isInDeviceCart(this.selectedVariant?.id);
    return this.selectedVariant?.available
      ? isInCart
        ? StorefrontLayoutContext.Strings?.addedToCart
        : StorefrontLayoutContext.Strings?.addToCart
      : StorefrontLayoutContext.Strings?.soldOut;
  }

  renderVariants() {
    if (StorefrontLayoutContext.Settings?.EnableStorefrontLayoutVariantSelector && this.item?.productData?.variants?.length > 1) {
      return `
        <span class="swym-storefront-layout-price-devider">|</span>
        <div class="swym-storefront-layout-grid-item-variants-container">
          ${this.item.productData.options
            .map(
              (option, index) => `
                  ${index==0?'':'<span class="swym-storefront-layout-variant-devider"></span>'}
                  <div id="variant-selector-${this.item.empi}" class="swym-storefront-layout-variant">
                    ${option.values
                      .map(
                        (value) =>
                          
                        this.selectedVariant[`option${index + 1}`] === value?value:''
                      )
                      .join('')}
                  </div>
                `
            )
            .join('')}
        </div>
      `;
    }
    return '';
  }

  renderVariantSelector() {
    if (StorefrontLayoutContext.Settings?.EnableStorefrontLayoutVariantSelector && this.item?.productData?.variants?.length > 1) {
      return `
        <div class="swym-storefront-layout-grid-item-variant-selector-container">
          ${this.item.productData.options
            .map(
              (option, index) => `
                ${option.values && option.values.length>1 ? `
                  <select id="variant-selector-${this.item.empi}" class="swym-storefront-layout-variant-selector">
                    <option value="${option.name}" disabled>${option.name}</option>
                    ${option.values
                      .map(
                        (value) =>
                          `<option value="${value}" ${
                            this.selectedVariant[`option${index + 1}`] === value ? 'selected' : ''
                          }>${value}</option>`
                      )
                      .join('')}
                  </select>
                `:''}
              `
            )
            .join('')}
        </div>
      `;
    }
    return '';
  }

  renderOptionButton() {
    //let canEdit = this.list?.userinfo?.em === StorefrontLayoutContext.SwymCustomerData?.email || this.list?.canEdit || !this.list?.userinfo;
    if (StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection || StorefrontLayoutContext.checkUserCanEditList(this.list)) {
      return `
        <div id="swym-storefront-layout-grid-item-option-button" class="swym-storefront-layout-grid-item-option-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
            <circle cx="1.5" cy="1.50014" r="1.5" fill="#B1B7C3"/>
            <circle cx="1.5" cy="6.50014" r="1.5" fill="#B1B7C3"/>
            <circle cx="1.5" cy="11.5001" r="1.5" fill="#B1B7C3"/>
          </svg>
        </div>
      `;
    }
    return '';
  }

  renderDeleteButton() {
    //let canEdit = this.list?.userinfo?.em === StorefrontLayoutContext.SwymCustomerData?.email || this.list?.canEdit || !this.list?.userinfo;
    if (StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection || StorefrontLayoutContext.checkUserCanEditList(this.list)) {
      return `
        <div id="swym-storefront-layout-grid-item-delete-button" class="swym-storefront-layout-grid-item-delete-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 20 20" fill="currentColor">
            <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="transparent"/>
            <path d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z" fill="#4A4A4A"/>
          </svg>
        </div>
      `;
    }
    return '';
  }

  renderItem() {

    let localizedUrl = this.item.du
    const locale = window.Shopify.routes.root

    if (locale !== '/') {
      const splitUrl = this.item.du.split('/products/')
      localizedUrl = `${splitUrl[0]}${locale}products/${splitUrl[1]}`
    }

    let comparePrice = this.getFormattedComparePrice();

    if(this.viewType == 'Grid'){
      this.innerHTML = `
        <div class="swym-storefront-layout-grid-item swym-storefront-layout-list-item-as-grid">
          <a href="${localizedUrl}" class="swym-storefront-layout-grid-item-image-container">
            <img src="${this.getProductImage()}" class="swym-storefront-layout-grid-item-image" />
          </a>
          <div class="swym-storefront-layout-grid-item-content">
            <div class="swym-storefront-layout-grid-item-info">
              <div class="swym-storefront-layout-grid-item-title">${this.item?.dt || ''}</div>
              <div class="swym-storefront-layout-grid-item-price-variant ${comparePrice?'swym-storefront-layout-grid-item-price-has-compare':''}">
                <span class="swym-storefront-layout-grid-item-final-price">${this.getFormattedPrice()}</span>
                ${comparePrice?`<span class="swym-storefront-layout-grid-item-compare-price">${comparePrice}</span>`:''}
              </div>
            </div>
            <div>
              ${this.renderVariants()}
            </div>
            <div class="swym-storefront-layout-grid-item-action-container">
              <button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart"
                ${!this.selectedVariant?.available ? 'disabled' : ''}>
                ${this.getButtonState()}
              </button>
            </div>
          </div>
          ${this.renderDeleteButton()}
        </div>
      `;
    }else{
       this.innerHTML = `
        <div class="swym-storefront-layout-grid-item">
          <a href="${localizedUrl}" class="swym-storefront-layout-grid-item-image-container">
            <img src="${this.getProductImage()}" class="swym-storefront-layout-grid-item-image" />
          </a>
          <div class="swym-storefront-layout-grid-item-content">
            <div class="swym-storefront-layout-grid-item-title">${this.item?.dt || ''}</div>
            <div class="swym-storefront-layout-grid-item-price-variant ${comparePrice?'swym-storefront-layout-grid-item-price-has-compare':''}">
              <span class="swym-storefront-layout-grid-item-final-price">${this.getFormattedPrice()}</span>
              ${comparePrice?`<span class="swym-storefront-layout-grid-item-compare-price">${comparePrice}</span>`:''}
              ${this.renderVariants()}
            </div>
            <div class="swym-storefront-layout-grid-item-action-container">
              <button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart"
                ${!this.selectedVariant?.available ? 'disabled' : ''}>
                ${this.getButtonState()}
              </button>
            </div>
          </div>
          ${this.renderDeleteButton()}
        </div>
      `; 
    }

    this.initItemElements();

    this.addEventListeners();
  }

  initItemElements(){
    this.elements = {
      AddToCartButton: this.querySelector('[data-action="add-to-cart"]'),
      Image: this.querySelector('.swym-storefront-layout-grid-item-image'),
      Price: this.querySelector('.swym-storefront-layout-grid-item-final-price'),
      ComparePrice: this.querySelector('.swym-storefront-layout-grid-item-compare-price'),
      OptionButton: this.querySelector('#swym-storefront-layout-grid-item-option-button'),
      DeleteButton: this.querySelector('#swym-storefront-layout-grid-item-delete-button')
    }
    
  }

  addEventListeners() {
    this.elements.AddToCartButton?.addEventListener('click', (event) => {
      this.handleAddToCart(event);
    });
    this.elements.OptionButton?.addEventListener('click', (event) => {
      if(StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
        StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.closeTooltip();
      }else{
        StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.setData({
          listId: this.list.lid,
          list: this.list,
          item: this.item,
          selectedVariantId: this.selectedVariant?.id,
          collections: this.collections,
          actionType: StorefrontLayoutContext.ActionTypes.ManageListItem
        });
        StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
      }
    });

    this.elements.DeleteButton?.addEventListener('click', async () => {
        try {
          let { epi, empi, du } = this.item;
          let listId = this.list.lid;
          await StorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, listId);
          this?.remove();
        } catch (error) {
          window._swat?.utils.error('Failed to remove product from the list:', error);
        }
    });
    
    const variantSelectors = this.querySelectorAll('.swym-storefront-layout-variant-selector');
    variantSelectors?.forEach((selector) =>
      selector.addEventListener('change', () => this.handleVariantSelectionChange())
    );
  }

  handleAddToCart(event) {
    event.preventDefault();
    let button = event.target;

    let { empi, epi, du } = this.dataset;

    let originalButtonState = button.innerHTML;
    button.innerHTML = StorefrontLayoutContext.Strings?.addingToCart;

    _swat.replayAddToCart(
      { empi: +empi, du: du, qty: 1 },
      +epi,
      async (success) => {
        button.innerHTML = StorefrontLayoutContext.Strings?.addedToCart;

        await this.removeProduct();
        StorefrontLayoutExtensions.Notification?.setMessage({
          message: StorefrontLayoutContext.Strings?.notificationMessageAddedToCart,
          status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
          actionType: StorefrontLayoutContext.NotificationActionTypes.AddedToCart,
          image: this.item.iu,
          product: this.item,
          duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
          action: {
            label: StorefrontLayoutContext.Strings?.notificationActionGoToCart,
            onClick: () => {
              window.location = "/cart" ;
            }
          }
        }, {
          showActionButton: true,
          showTitle: true
        });

        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutItemAddedToCart, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutCartConversion, epi, empi });

      },
      (error) => {
        button.innerHTML = originalButtonState;
        window._swat?.utils.warn('Error :', error.description);
        StorefrontLayoutExtensions.Notification?.setMessage({
          title: error.description,
          status: StorefrontLayoutContext.NotificationStatusTypes?.Error
        },{
          showTitle: true,
          showImage: false
        });
      }
    );
  }

  async removeProduct(){
      try {

        let { empi, epi, du } = this.dataset;
        
        // if(this.currentSlectedVariantId){
        //   epi = this.currentSlectedVariantId;
        // }
        await StorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, this.list.lid);

        let elementDeleted = this.elements.wishlistItemsContainer?.querySelector(`[data-epi="${epi}"]`);
        elementDeleted?.remove();

        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutItemRemovedFromList, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutWishlistItemInteractions, epi, empi });

      } catch (error) {
        window._swat?.utils.error('Failed to remove product from the list:', error);
      }
  }

  async handleVariantSelectionChange() {

    let selectedOptions = {};
    const variantSelectors = this.querySelectorAll(".swym-storefront-layout-variant-selector");
    
    variantSelectors.forEach((selector) => {
      const selectedValue = selector.value?.trim();
      const optionIndex = selector.dataset.optionindex;
    
      if (selectedValue && optionIndex) {
        selectedOptions[`option${optionIndex}`] = selectedValue;
      }
    });
    
    const selectedVariant = this.item.productData.variants.find((variant) =>
      Object.entries(selectedOptions).every(([key, value]) => variant[key] === value)
    );

    this.selectedVariant = selectedVariant;
    this.dataset.epi = selectedVariant.id;
    this.item.cprops = this.item.cprops ?? {};
    this.item.cprops.selectedVariantId = selectedVariant.id;

    if (selectedVariant) {
      this.elements.AddToCartButton.textContent = this.getButtonState();
      if (selectedVariant.available) {
        this.elements.AddToCartButton.removeAttribute('disabled');
      } else {
        this.elements.AddToCartButton.setAttribute('disabled', true);
      }

      this.elements.Price.textContent =this.getFormattedPrice();
      this.elements.ComparePrice.textContent = this.getFormattedComparePrice();

      const productImage = selectedVariant?.featured_image?.src || this.item.productData?.featured_image || item.iu;
      this.elements.Image.src = productImage;

      let canEdit = (this.list?.userinfo?.em === StorefrontLayoutContext.SwymCustomerData?.email) || this.list?.canEdit;

      if(StorefrontLayoutContext.checkUserCanEditList(this.list)){
        let { epi, empi, du } = this.item;
        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutVariantChanged, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutWishlistItemInteractions, epi, empi });
        await StorefrontLayoutAPI?.SwymWLAsyncApis?.updateProductFromList({ epi, empi, du, cprops: { selectedVariantId: selectedVariant.id } }, this.list.lid);
      }
    } else {
      window._swat?.utils.warn("No matching variant found for the selected options:", selectedOptions);
    }
  }

}

/**
 * SwymStorefrontLayoutDefaultWishList
 * 
 * This custom HTML element represents the default wishlist layout in the storefront.
 * It handles rendering wishlist items dynamically and updating the UI when new wishlist data is set.
 * 
 * Features:
 * - Initializes with a loading state until wishlist data is available.
 * - Fetches product details for wishlist items and updates the UI.
 * - Displays an empty state when no wishlist items exist.
 * - Uses Swym API and instrumentation to track interactions.
 * 
 * Usage:
 * <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
 */
class SwymStorefrontLayoutDefaultWishList extends HTMLElement {
  constructor() {
    super();
    this.wishlist = null;
    this.collections = null;
    this.renderUI();
    this.elements = {
      title: this.querySelector('.swym-storefront-layout-default-list-title'),
      itemsContainer: this.querySelector('#swymcs-storefront-layout-items-container')
    }
  }

  renderUI() {
    this.innerHTML = `
      <div class="swym-storefront-layout-default-list-container">
      ${StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection ? `
          <div class="swym-storefront-layout-default-list-title-container">
            <div class="swym-storefront-layout-default-list-title">${StorefrontLayoutContext.Strings?.wishlistTitle}</div>
            <div class="swym-storefront-layout-default-list-info">${StorefrontLayoutContext.Strings?.wishlistInfo}</div>
          </div>
        ` : ''}
        <div id="swymcs-storefront-layout-items-container" class="swym-storefront-layout-items-container">
          <swym-storefront-layout-loader loading="true" loadertype="${StorefrontLayoutContext.LoaderViewType.WishlistListItem}" height="100px"></swym-storefront-layout-loader>
        </div>
      </div>
    `
  }

  setData({ wishlist, collections }) {
    this.wishlist = wishlist;
    this.collections = collections;
    this.elements.itemsContainer.dataset.lid = this.wishlist?.lid;
    this.renderWishlist();
  }

  async renderWishlist() {
    if (this.wishlist?.listcontents?.length && this.elements.itemsContainer) {
      
      window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutWishlistItemsRendered, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });

      const wishlistedProducts = await StorefrontLayoutAPI.SwymWLAsyncApis.fetchProductData(this.wishlist.listcontents, StorefrontLayoutContext.fromCache);
      const fragment = document.createDocumentFragment();

      wishlistedProducts.forEach((item) => {
        const wishlistItem = document.createElement('template');
        wishlistItem.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-item-${item.empi}-${item.epi}" ></swym-storefront-layout-item>`;
        fragment.appendChild(wishlistItem.content);
      });
      
      this.elements.itemsContainer.innerHTML = '';
      this.elements.itemsContainer.appendChild(fragment);

      wishlistedProducts.forEach((item) => {
        let wishlistItemElement = document.querySelector(`#swym-storefront-layout-item-${item.empi}-${item.epi}`);
        wishlistItemElement?.setData({
          item,
          list: this.wishlist,
          collections: this.collections
        })
      });
      this.elements.itemsContainer.classList.remove('swym-storefront-layout-items-has-empty');
    }else{
      this.elements.itemsContainer.innerHTML = `
        <div class="swym-storefront-layout-empty-container">
          <div class="swym-storefront-layout-empty-wishlist-container">
            <div class="swym-storefront-layout-empty-wishlist-content">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="86" height="85" viewBox="0 0 86 85" fill="none">
                <rect width="59.5441" height="78.6833" transform="translate(0.710449 6.1748) rotate(-5.46887)" fill="white"/>
                <rect x="0.710938" y="6.1748" width="59.5441" height="78.6833" rx="1.21519" transform="rotate(-5.46887 0.710938 6.1748)" fill="#FDFDFD"/>
                <rect x="0.983626" y="6.39984" width="59.0441" height="78.1833" rx="0.965186" transform="rotate(-5.46887 0.983626 6.39984)" stroke="black" stroke-opacity="0.1" stroke-width="0.5"/>
                <rect x="5.57364" y="10.7446" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 5.57364 10.7446)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="13.0841" y="11.0938" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.0841 11.0938)" fill="#D0D0D0"/>
                <rect x="6.44223" y="19.8169" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 6.44223 19.8169)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="13.9527" y="20.166" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.9527 20.166)" fill="#D0D0D0"/>
                <rect x="7.31107" y="28.8892" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 7.31107 28.8892)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="14.8214" y="29.2383" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 14.8214 29.2383)" fill="#D0D0D0"/>
                <rect x="8.17942" y="37.9619" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 8.17942 37.9619)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="15.6899" y="38.311" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 15.6899 38.311)" fill="#D0D0D0"/>
                <rect x="9.04825" y="47.0342" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.04825 47.0342)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="16.5587" y="47.3833" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 16.5587 47.3833)" fill="#D0D0D0"/>
                <rect x="9.91666" y="56.1069" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.91666 56.1069)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="17.4271" y="56.4561" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 17.4271 56.4561)" fill="#D0D0D0"/>
                <rect x="10.7854" y="65.1792" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 10.7854 65.1792)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="18.2959" y="65.5283" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 18.2959 65.5283)" fill="#D0D0D0"/>
                <rect x="11.6538" y="74.2515" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 11.6538 74.2515)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                <rect x="19.1643" y="74.6006" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 19.1643 74.6006)" fill="#D0D0D0"/>
                <rect x="55.0288" y="35.834" width="31.0853" height="31.0853" transform="rotate(13.2248 55.0288 35.834)" fill="url(#pattern0_489_1797)"/>
                <defs>
                <pattern id="pattern0_489_1797" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_489_1797" transform="scale(0.0104167)"/>
                </pattern>
                <image id="image0_489_1797" width="96" height="96" xlink:href="data:image/png;base64,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"/>
                </defs>
              </svg>
              <div class="swym-storefront-layout-empty-wishlist-title">${StorefrontLayoutContext.Strings?.emptyWishlistTitle}</div>
              <div class="swym-storefront-layout-empty-wishlist-description">${StorefrontLayoutContext.Strings?.emptyWishlistDescription}</div>
            </div>
          </div>
        </div>
      `;
      this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
    }

    let wishlistCount = this.wishlist?.listcontents?.length || 0;
    if(this.elements.title){
      this.elements.title.innerHTML = `${StorefrontLayoutContext.Strings?.wishlistTitle} ${wishlistCount?`(${wishlistCount})`:''}`;
    }
  }


}

/**
 * SwymStorefrontLayoutCollectionList
 *
 * A custom HTML element representing a collection list within the Swym Storefront Layout.
 * This component is responsible for rendering a list of collections, displaying wishlist items, 
 * handling user interactions, and managing collection data.
 *
 * Features:
 * - Initializes and renders the UI dynamically.
 * - Fetches and displays wishlist items for a collection.
 * - Handles user permissions for editing or saving collections.
 * - Provides UI elements like back navigation, action buttons, and collection details.
 *
 * Usage:
 * ```html
 * <swym-storefront-layout-collection-list></swym-storefront-layout-collection-list>
 * ```
 * JavaScript:
 * ```js
 * const collectionListElement = document.createElement('swym-storefront-layout-collection-list');
 * collectionListElement.setData({ list: myList, collections: myCollections });
 * document.body.appendChild(collectionListElement);
 * ```
 */
class SwymStorefrontLayoutCollectionList extends HTMLElement {
  constructor() {
    super();
    this.collectionList = null;
    this.collections = null;
  }

  initUI(){
    this.renderUI();
    this.elements = {
      backButton: this.querySelector('.swym-storefront-layout-collection-list-back-button'),
      itemsContainer: this.querySelector('#swym-storefront-layout-collection-list-items-container'),
      collectionCount: this.querySelector('.swym-storefront-layout-collection-items-count'),
      title: this.querySelector('.swym-storefront-layout-collection-title'),
      swymListActionButton: this.querySelector('#swym-storefront-layout-collection-option-button'),
      userAccessInfo: this.querySelector('#swym-storefront-layout-collection-list-access-info'),
      collectionImages: this.querySelector('#swym-storefront-layout-collection-list-images-container')
    }
    this.addEventListenerToView();
  }

  setData({ list, collections }) {
    this.initUI();
    this.renderLoader();
    this.collectionList = list;
    this.collections = collections;
    if(this.collectionList){
      this.elements.itemsContainer.dataset.lid = this.collectionList.lid;
      this.canEdit = StorefrontLayoutContext.checkUserCanEditList(this.collectionList);
      this.renderCollectionlist();
    }
  }

  renderUI() {
    this.innerHTML = `
    <div class="swym-storefront-layout-collection-list-container">
      <div class="swym-storefront-layout-collection-list-header">
        <div id="swym-storefront-layout-collection-list-images-container">
        </div>
        <div class="swym-storefront-layout-collection-list-header-content">
          <div class="swym-storefront-layout-collection-list-back-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z" fill="#4A4A4A"/>
            </svg>
          </div>
          <div class="swym-storefront-layout-collection-title-container">
            <div class="swym-storefront-layout-collection-title">Shared Wishlist</div>
            <div class="swym-storefront-layout-collection-items-count"></div>
            <button type="button" class="swym-storefront-layout-action-tooltip-btn add-all-to-cart-button shared-wishlist-add-all-to-cart-button">Add All to Cart</button>
            <div id="swym-storefront-layout-collection-option-button" class="swym-storefront-layout-collection-option-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
                <circle cx="1.5" cy="1.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="6.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="11.5001" r="1.5" fill="currentColor"></circle>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="swym-storefront-layout-collection-list-content swym-storefront-layout-scrollable">
        <div id="swym-storefront-layout-collection-list-access-info"></div>
        <div id="swym-storefront-layout-collection-list-items-container" class="swym-storefront-layout-items-container">
        </div>
      </div>
    </div>
    `
  }

  addEventListenerToView() {
    this.elements.backButton.addEventListener('click', () => {
      window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.List;
      this.closeCollectinListView()
    });

    this.elements.swymListActionButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if(StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
        StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.closeTooltip();
      }else{
        if(this.canEdit){
          StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.setData({
            listId: this.collectionList.lid,
            list: this.collectionList,
            collections: this.collections,
            actionType: StorefrontLayoutContext.ActionTypes.EditCollection
          });
        }else{
          StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.setData({
            listId: this.collectionList.lid,
            list: this.collectionList,
            collections: this.collections,
            actionType: StorefrontLayoutContext.ActionTypes.SaveCollection
          });
        }
        StorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
      }
    });

    const addAllSharedBtn = this.querySelector('.shared-wishlist-add-all-to-cart-button');
    addAllSharedBtn?.addEventListener('click', async () => {
      try {
        const sourceItems = this.collectionList?.listcontents || [];
        let itemsToAdd = sourceItems.filter((item) =>
          {
            let isInCart = _swat.platform.isInDeviceCart(item.epi);
            return item.productData?.variants.find((variant) => variant.id === item.epi) && item.productData?.variants.find((variant) => variant.id === item.epi).available && !isInCart;
          }
        ).map((item) => {
          return {
            epi: item.epi,
            empi: item.empi,
            qty: 1
          }
        });
        if(itemsToAdd.length > 0){
            _swat.platform.addAllToCart(itemsToAdd, async () => {
              console.log('swym addAllToCart success');
              await StorefrontLayoutAPI?.SwymWLAsyncApis?.updateList();
              window._cartRefresh();
              document.querySelector('cart-drawer').open()
            },
            (error) => {
              StorefrontLayoutExtensions.Notification?.setMessage({
                message: 'Error adding items to cart',
                status: StorefrontLayoutContext.NotificationStatusTypes?.Error
              });
              console.log('swymaddAllToCart error', error);
            }
          );
        }else{
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: 'No new items to add to cart. Items may already exist in your cart',
            status: StorefrontLayoutContext.NotificationStatusTypes?.Error
          });
        }
      } catch (error) {
        window._swat?.utils.error('swym Failed to add all to cart:', error);
      }
    });
  }

  async renderCollectionlist() {
    if (this.collectionList && this.collectionList.listcontents && this.elements.itemsContainer) {

      this.elements.title.innerHTML = `<div class="swym-storefront-layout-collection-title">Shared Wishlist</div>`;

      let itemsCount = this.collectionList?.listcontents?.length || 0;
      this.elements.collectionCount.innerHTML = itemsCount?`${itemsCount} ${itemsCount<=1? StorefrontLayoutContext.Strings?.item : StorefrontLayoutContext.Strings?.items }`:'';
      
      const wishlistedProducts = await StorefrontLayoutAPI.SwymWLAsyncApis.fetchProductData(this.collectionList.listcontents, StorefrontLayoutContext.fromCache);
      const fragment = document.createDocumentFragment();

      this.elements.collectionImages.innerHTML = `
        <div class="swym-storefront-layout-collection-list-images">
          ${wishlistedProducts.slice(0, 5).map((item, index) => 
            item 
              ? `<img class="swym-storefront-layout-collection-list-image swym-storefront-layout-collection-list-image-${index}" src="${item.iu}" alt="Wishlist Image">`
              : ``
          ).join('')}
        </div>
      `;

      

      if(itemsCount){
        wishlistedProducts.forEach((item) => {
          const wishlistItem = document.createElement('template');
          wishlistItem.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-collection-item-${item.empi}-${item.epi}" ></swym-storefront-layout-item>`;
          fragment.appendChild(wishlistItem.content);
        });
        
        this.elements.itemsContainer.innerHTML = '';
        this.elements.itemsContainer.appendChild(fragment);
  
        wishlistedProducts.forEach((item) => {
          let wishlistItemElement = document.querySelector(`#swym-storefront-layout-collection-item-${item.empi}-${item.epi}`);
          wishlistItemElement?.setData({
            item,
            list: this.collectionList,
            collections: this.collections
          })
        });
      }else{
        this.renderEmptyView();
      }

      let isUserLogged = !!window.swymCustomerId;
      if(isUserLogged && !!this.collectionList?.userinfo?.em && this.collectionList?.userinfo?.em != StorefrontLayoutContext.SwymCustomerData?.email){
        let userinfo = this.collectionList?.userinfo;
        let username = [userinfo?.fname, userinfo?.lname].filter(Boolean).join(" ");
        let usersharedby = username.trim() || userinfo?.em;
        let email = usersharedby;
        this.elements.userAccessInfo.innerHTML = window._swat?.utils?.renderTemplateString( StorefrontLayoutContext.Strings?.sharedCollectionMessage, { usersharedby, email });
      }else{
        this.elements.userAccessInfo.innerHTML = ``;
      }

      this.openCollectionListView();
    }
  }

  renderEmptyView(){
    this.elements.itemsContainer.innerHTML = `
      <div class="swym-storefront-layout-empty-container">
        <div class="swym-storefront-layout-empty-wishlist-container">
          <div class="swym-storefront-layout-empty-wishlist-content">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="86" height="85" viewBox="0 0 86 85" fill="none">
              <rect width="59.5441" height="78.6833" transform="translate(0.710449 6.1748) rotate(-5.46887)" fill="white"/>
              <rect x="0.710938" y="6.1748" width="59.5441" height="78.6833" rx="1.21519" transform="rotate(-5.46887 0.710938 6.1748)" fill="#FDFDFD"/>
              <rect x="0.983626" y="6.39984" width="59.0441" height="78.1833" rx="0.965186" transform="rotate(-5.46887 0.983626 6.39984)" stroke="black" stroke-opacity="0.1" stroke-width="0.5"/>
              <rect x="5.57364" y="10.7446" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 5.57364 10.7446)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="13.0841" y="11.0938" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.0841 11.0938)" fill="#D0D0D0"/>
              <rect x="6.44223" y="19.8169" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 6.44223 19.8169)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="13.9527" y="20.166" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.9527 20.166)" fill="#D0D0D0"/>
              <rect x="7.31107" y="28.8892" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 7.31107 28.8892)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="14.8214" y="29.2383" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 14.8214 29.2383)" fill="#D0D0D0"/>
              <rect x="8.17942" y="37.9619" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 8.17942 37.9619)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="15.6899" y="38.311" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 15.6899 38.311)" fill="#D0D0D0"/>
              <rect x="9.04825" y="47.0342" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.04825 47.0342)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="16.5587" y="47.3833" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 16.5587 47.3833)" fill="#D0D0D0"/>
              <rect x="9.91666" y="56.1069" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.91666 56.1069)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="17.4271" y="56.4561" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 17.4271 56.4561)" fill="#D0D0D0"/>
              <rect x="10.7854" y="65.1792" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 10.7854 65.1792)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="18.2959" y="65.5283" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 18.2959 65.5283)" fill="#D0D0D0"/>
              <rect x="11.6538" y="74.2515" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 11.6538 74.2515)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
              <rect x="19.1643" y="74.6006" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 19.1643 74.6006)" fill="#D0D0D0"/>
              <rect x="55.0288" y="35.834" width="31.0853" height="31.0853" transform="rotate(13.2248 55.0288 35.834)" fill="url(#pattern0_489_1797)"/>
              <defs>
              <pattern id="pattern0_489_1797" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_489_1797" transform="scale(0.0104167)"/>
              </pattern>
              <image id="image0_489_1797" width="96" height="96" xlink:href="data:image/png;base64,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"/>
              </defs>
            </svg>
            <div class="swym-storefront-layout-empty-wishlist-title">${StorefrontLayoutContext.Strings?.emptyCollectionText}</div>
            <div class="swym-storefront-layout-empty-wishlist-description">${StorefrontLayoutContext.Strings?.emptyCollectionDescription}</div>
          </div>
        </div>
      </div>
    `;
    this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
  }

  renderLoader(){
    this.elements.collectionImages.innerHTML = `<swym-storefront-layout-loader loading="true" loadertype="${StorefrontLayoutContext.LoaderViewType.CollectionImages}" height="80%"></swym-storefront-layout-loader>`;
    this.elements.itemsContainer.innerHTML = `<swym-storefront-layout-loader loading="true" loadertype="${StorefrontLayoutContext.LoaderViewType.WishlistListItem}" height="80%"></swym-storefront-layout-loader>`;
  }

  clearUI(){
    this.innerHTML = '';
  }

  openCollectionListView() {
    this.classList.add('swym-storefront-layout-show-collection-list');
    StorefrontLayoutExtensions.sectionContainerComponent?.classList.add('swym-storefront-layout-hide-list-view');
  }

  closeCollectinListView() {
    this.classList.remove('swym-storefront-layout-show-collection-list');
    StorefrontLayoutExtensions.sectionContainerComponent?.classList.remove('swym-storefront-layout-hide-list-view');
    setTimeout(()=>{
      this.clearUI();
    },100);
  }

}


/**
 * SwymStorefrontLayoutActions - Custom Web Component
 *
 * This class extends `HTMLElement` to create and manage the UI for wishlist-related actions 
 * in the Swym Storefront Layout. It handles functionalities such as:
 *
 * - Displaying a modal-like action panel for managing wishlist items.
 * - Supporting different action types (e.g., adding an item to a collection).
 * - Rendering the UI dynamically based on the selected list or collection.
 * - Managing event listeners to update UI interactions seamlessly.
 *
 * Key Features:
 * - Renders a structured UI layout with an image, title, options, and action buttons.
 * - Supports selecting collections and dynamically updates the UI upon selection.
 * - Implements event handling for collection management, including adding new collections.
 * - Uses `StorefrontLayoutContext` for accessing relevant wishlist and collection data.
 *
 * Usage:
 * - This component is initialized automatically when added to the DOM.
 * - Data can be set via `setData({ listId, list, item, selectedVariantId, collections, actionType })`.
 * - Internal methods like `renderAddToCollection()` handle specific UI updates.
 *
 * Example:
 * ```html
 * <swym-storefront-layout-actions></swym-storefront-layout-actions>
 * ```
 *
 * Dependencies:
 * - Requires `StorefrontLayoutContext` for accessing wishlist and collection data.
 * - Uses event listeners for handling user interactions.
 *
 * Notes:
 * - Ensures smooth UI updates with proper event handling and DOM manipulations.
 * - Uses query selectors to manage DOM elements efficiently.
 */
class SwymStorefrontLayoutActions extends HTMLElement {
  constructor() {
    super();

    this.actionType = StorefrontLayoutContext.ActionTypes.ManageListItem;

    this.wishlistItem = null;
    this.collections = null;
    this.listId = null;
    this.list = null;
    this.selectedCollectionLid = null;
    this.selectedList = null;
    this.renderUI();
    this.elements = {
      container: this.querySelector('.swym-storefront-layout-actions-container'),
      backdrop: this.querySelector('.swym-storefront-layout-action-backdrop'),
      closeButton: this.querySelector('.swym-storefront-layout-action-close-button'),
      title: this.querySelector('.swym-storefront-layout-action-title-container'),
      optionsContainer: this.querySelector('#swym-storefront-layout-action-options'),
      actionContianer: this.querySelector('#swym-storefront-layout-action-container'),
      wishlistItemsContainer: document.querySelector('#swymcs-storefront-layout-items-container'),
      imageContainer: this.querySelector('.swym-storefront-layout-action-image-container'),
      layoutContainer: this.querySelector('.swym-storefront-layout-action-layout')
    }
    this.addEventListenerToView();
  }

  renderUI() {
    this.innerHTML = `
    <div class="swym-storefront-layout-actions-container">
      <div class="swym-storefront-layout-action-backdrop"></div>
      <div class="swym-storefront-layout-action-layout">
        <div class="swym-storefront-layout-action-content">
          <div class="swym-storefront-layout-action-header">
            <div class="swym-storefront-layout-action-title-container"></div>
            <button class="swym-storefront-layout-action-close-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="white"/>
                <path d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z" fill="#4A4A4A"/>
              </svg>
            </button>
          </div>
          <div id="swym-storefront-layout-action-options"></div>
          <div id="swym-storefront-layout-action-container"></div>
        </div>
      </div>
    </div>
    `
  }

  setData({ listId, list, item, selectedVariantId, collections, actionType = StorefrontLayoutContext.ActionTypes.ManageListItem }) {
    this.listId = listId;
    this.list = list;
    this.wishlistItem = item;
    this.collections = StorefrontLayoutContext.collections;
    this.currentSlectedVariantId = selectedVariantId;
    this.selectedCollectionLid = this.collections[0]?.lid;
    this.selectedList = this.collections[0] || null;
    this.elements.wishlistItemsContainer = document.querySelector(`.swym-storefront-layout-items-container[data-lid="${listId}"]`);
    this.elements.actionContianer.innerHTML = '';
    this.elements.layoutContainer.setAttribute('id', `swym-storefront-layout-action-${actionType}`);
    if (actionType === StorefrontLayoutContext.ActionTypes.AddToCollection) {
      this.renderAddToCollection();
    }else if (actionType === StorefrontLayoutContext.ActionTypes.ShareList){
      this.renderShareList();
    } 
    StorefrontLayoutExtensions.checkContainerScrollbar(this.elements.optionsContainer);
  }

  getSelectedVariant(item) {
    const selectedVariantId = this.currentSlectedVariantId || item.epi;
    return item.productData.variants.find((variant) => variant.id === selectedVariantId);
  }

  async renderAddToCollection() {
    this.collections = StorefrontLayoutContext.collections || [];
    if (this.collections && this.elements.optionsContainer) {

      
      this.elements.title.innerHTML = `
        <div class="swym-storefront-layout-action-addtocollection-title">
          <div class="swym-storefront-layout-action-product-title">${this.wishlistItem.dt}</div>
          <div class="swym-storefront-layout-action-title">${StorefrontLayoutContext.Strings?.addToCollectionTitle}</div>
        </div>
      `
      this.renderCollectionOptions();
      this.renderCreteCollectionAction()
    }
  }

  renderCollectionOptions(){
    this.elements.optionsContainer.innerHTML = `
        ${this.collections.map((collection) => {

        let { lid, lname, listcontents } = collection;
        let item = listcontents[0];
        let count = listcontents.length;

        const listImagesHtml = Array.from({ length: 3 })
          .map((_, i) => {
            let item = listcontents[i];
            return `
            <div class="${i === 0 ? 'swym-storefront-layout-action-collection-item-image-primary' : 'swym-storefront-layout-action-collection-item-image-secondary'} ">
              ${item?.iu ? `<img src="${item ? item.iu : null}" class="swym-storefront-layout-action-collection-item-image" />` : `<div class="swym-storefront-layout-action-collection-item-image" ></div>`}
            </div>
          `;
          })
          .join("");

        return `
            <div class="swym-storefront-layout-collection-action-btn add-item-to-collection swym-storefront-layout-action-collection-item-container ${this.selectedCollectionLid === lid?'swym-storefront-layout-radio-selected':''}" data-lid="${lid}">
              <div class="swym-storefront-layout-action-collection-image-container">
                ${listImagesHtml}
              </div>
              <div class="swym-storefront-layout-action-collection-content">
                <div class="swym-storefront-layout-action-collection-item-name">${lname}</div>
                <div class="swym-storefront-layout-action-collection-item-count">${count} ${count === 1 ? 'item' : 'items'}</div>
              </div>
              <div class="swym-storefront-layout-radio-container">
                <label class="swym-storefront-layout-radio">
                  <input type="radio" ${this.selectedCollectionLid === lid?'checked':''} name="swym-storefront-layout-collections">
                  <span class="swym-storefront-layout-checkmark"></span>
                </label>
              </div>
            </div>
          `
      }).join('')}
      `;

      this.addMangeCollectionEventListeners();
  }

  addMangeCollectionEventListeners() {
    this.collections.forEach((collection) => {
      const collectionItem = this.elements.optionsContainer.querySelector(
        `[data-lid="${collection.lid}"]`
      );
      collectionItem?.addEventListener("click", async (event) => {

        const collectionSaveButton = this.querySelector('#swym-storefront-layout-save-collection-list-button');

        this.selectedCollectionLid = collection.lid;
        this.selectedList = collection;
        collectionSaveButton.disabled = false;
        this.renderCollectionOptions();
      });
    })
  }

  renderCreteCollectionAction(){
    this.elements.actionContianer.innerHTML = `
        <form id="swym-storefront-layout-create-collection-form">
          <div class="swym-storefront-layout-create-collection-name-form-group ${this.selectedCollectionLid === 'fromInput'?'swym-storefront-layout-radio-selected':''}">
            <input
              type="text"
              id="swym-storefront-layout-create-collection-name-input"
              class="swym-storefront-layout-action-input create-collection-name-input"
              placeholder="${StorefrontLayoutContext.Strings?.createCollectionCta}"
            />
            <div class="swym-storefront-layout-radio-container">
              <label class="swym-storefront-layout-radio">
                <input type="radio" ${this.selectedCollectionLid === 'fromInput'?'checked':''} name="swym-storefront-layout-collections">
                <span class="swym-storefront-layout-checkmark"></span>
              </label>
            </div>
            <div id="swym-storefront-layout-create-collection-error-message-container" class="error-message" style="display: none;">
              <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="base-icon error-icon" aria-hidden="true"><path d="M7 .7a6.3 6.3 0 1 0 0 12.6A6.3 6.3 0 0 0 7 .7Zm.7 9.8H6.3V9.1h1.4v1.4Zm0-2.1H6.3V3.5h1.4v4.9Z" fill="currentColor"></path></svg>
              <span id="swym-storefront-layout-create-collection-error-message">Name is required</span>
            </div>
          </div>
          <button type="submit" id="swym-storefront-layout-save-collection-list-button" class="swym-storefront-layout-save-collection-list-button">${StorefrontLayoutContext.Strings?.addToCollectionCta}</button>
        </form>
      `;
      this.addCreateCollectionEventListeners();
  }

  addCreateCollectionEventListeners() {
    const createCollectionForm = this.querySelector('#swym-storefront-layout-create-collection-form');
    const collectionNameInputContainer = this.querySelector('.swym-storefront-layout-create-collection-name-form-group');
    const collectionNameInput = this.querySelector('#swym-storefront-layout-create-collection-name-input');

    collectionNameInput.addEventListener("focus", () => {
      this.selectedCollectionLid = 'fromInput';
      collectionNameInputContainer.classList.add('swym-storefront-layout-radio-selected');
      this.renderCollectionOptions();
      this.validateCollectionInputField(false);
    });
    
    collectionNameInput.addEventListener("blur", () => {
      collectionNameInputContainer.classList.remove('swym-storefront-layout-radio-selected');
    });

    collectionNameInput.addEventListener('input', () => {
      this.validateCollectionInputField();
    });

    

    createCollectionForm.addEventListener('submit', async (event) => {
      try {
        event.preventDefault();
        let listIdToAdd;
        if(this.selectedCollectionLid === 'fromInput'){
          let name = collectionNameInput.value.trim();
          let newList = await StorefrontLayoutAPI?.SwymWLAsyncApis?.createList(name);
          listIdToAdd = newList.lid;
          this.selectedList = newList;
        }else{
          listIdToAdd = this.selectedCollectionLid;
        }
        let { epi, empi, du, iu } = this.wishlistItem;

        if(listIdToAdd){
          this.closeDrawer();
          await StorefrontLayoutAPI?.SwymWLAsyncApis?.addProductsToList([{ empi, epi, du }], listIdToAdd);
          StorefrontLayoutExtensions.Notification?.setMessage({
            title: StorefrontLayoutContext.Strings?.notificationMessageAddedToCollection,
            message: this.selectedList?.lname,
            status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
            actionType: StorefrontLayoutContext.NotificationActionTypes.AddedToCollection,
            duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
            product: this.wishlistItem,
            image:iu,
            action: {
                label: StorefrontLayoutContext.Strings?.notificationActionViewCollection,
                onClick: () => {
                  window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList + listIdToAdd;
                }
            }
          },{
            showActionButton: true,
            showTitle: true,
            showProgress: true
          });
          window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutCollectionCreated, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutCollectionInteractions });

        }
      } catch (error) {
        window._swat?.utils.error('Error on create and add product to list', error);
      }
    }); 

    // auto focus create collection input by default when no collection available
    if(!this.collections?.length){
      setTimeout(() => {
        collectionNameInput?.focus();
      }, 50);
    }
  }

  validateCollectionInputField(showError = true){

    const collectionNameInput = this.querySelector('#swym-storefront-layout-create-collection-name-input');
    const collectionSaveButton = this.querySelector('#swym-storefront-layout-save-collection-list-button');
    const errorMessageContainer = this.querySelector('#swym-storefront-layout-create-collection-error-message-container');
    const errorMessage = this.querySelector('#swym-storefront-layout-create-collection-error-message');

    let name = collectionNameInput.value.trim();
    let error;

    let isNameExist = this.collections.some(collection => collection.lname.toLowerCase() === name.toLowerCase());

    if (name === '') {
      error = StorefrontLayoutContext.Strings?.errorMessageListNameRequired;
    } else if (name.length < 3) {
      error = StorefrontLayoutContext.Strings?.errorMessageListNameRequire3Char;
    }else if(isNameExist){
      error = StorefrontLayoutContext.Strings?.errorMessageListNameAlreadyExist;
    }

    if (name.length > 0) {
      collectionNameInput.classList.add('swym-storefront-layout-input-has-value');
    } else {
      collectionNameInput.classList.remove('swym-storefront-layout-input-has-value');
    }

    if (error) {
      if(showError){
        errorMessage.innerHTML = error;
        errorMessageContainer.style.display = 'flex';
        collectionNameInput.classList.add('swym-storefront-layout-input-has-error');
      }
      collectionSaveButton.disabled = true;
    } else {
      errorMessage.innerHTML = '';
      errorMessageContainer.style.display = 'none';
      collectionSaveButton.disabled = false;
      collectionNameInput.classList.remove('swym-storefront-layout-input-has-error');
    }
  }

  addEventListenerToView() {
    this.elements.backdrop.addEventListener('click', () => this.closeDrawer());
    this.elements.closeButton.addEventListener('click', () => this.closeDrawer());
  }

  renderShareList(){
      
      this.elements.title.innerHTML = `
        <div class="swym-storefront-layout-action-addtocollection-title">
          <div class="swym-storefront-layout-action-title">${StorefrontLayoutContext?.Strings?.shareListTitle}</div>
        </div>
      `
    

      this.elements.optionsContainer.innerHTML = `
        <form id="swym-custom-share-form">
            <div id="swym-share-label-and-input-wrapper">
            <lable class="swym-lable-help-text">${StorefrontLayoutContext?.Strings?.shareListLableSenderName}</lable>
            <input id="swym-sender-name" value="${StorefrontLayoutContext?.SwymCustomerData?.name}" type="text">
            <lable class="swym-lable-help-text">${StorefrontLayoutContext?.Strings?.shareListLableEmail}</lable>
            <input id="swym-recepient-email" placeholder="${StorefrontLayoutContext?.Strings?.shareListEmailPlaceholder}" type="email" required="required">
            <lable class="swym-lable-help-text">${StorefrontLayoutContext?.Strings?.shareListLableMessage}</lable>
            <textarea id="swym-share-message" type="text">${StorefrontLayoutContext?.Strings?.shareListMessage}</textarea>
            <div class="swym-form-help-text">${StorefrontLayoutContext?.Strings?.shareListInputHelpText}</div>
            </div>
            <div class="swym-custom-share-action-container">
              <button id="swym-custom-share-submit-button" type="submit">${StorefrontLayoutContext?.Strings?.shareListButtonCta}</button>
            </div>
        </form>
      `

    this.elements.actionContianer.innerHTML = `
      <div class="swym-share-via-social-container">
        <lable class="swym-share-via-help-text">${StorefrontLayoutContext?.Strings?.shareListShareViaHelpText}</lable>
        <div id="swymcs-additional-share-buttons-container">
          <button id="swym-custom-share-copy-link" >
              <div class="swymcs-share-buttons-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M13.723 18.654l-3.61 3.609c-2.316 2.315-6.063 2.315-8.378 0-1.12-1.118-1.735-2.606-1.735-4.188 0-1.582.615-3.07 1.734-4.189l4.866-4.865c2.355-2.355 6.114-2.262 8.377 0 .453.453.81.973 1.089 1.527l-1.593 1.592c-.18-.613-.5-1.189-.964-1.652-1.448-1.448-3.93-1.51-5.439-.001l-.001.002-4.867 4.865c-1.5 1.499-1.5 3.941 0 5.44 1.517 1.517 3.958 1.488 5.442 0l2.425-2.424c.993.284 1.791.335 2.654.284zm.161-16.918l-3.574 3.576c.847-.05 1.655 0 2.653.283l2.393-2.389c1.498-1.502 3.94-1.5 5.44-.001 1.517 1.518 1.486 3.959 0 5.442l-4.831 4.831-.003.002c-1.438 1.437-3.886 1.552-5.439-.002-.473-.474-.785-1.042-.956-1.643l-.084.068-1.517 1.515c.28.556.635 1.075 1.088 1.528 2.245 2.245 6.004 2.374 8.378 0l4.832-4.831c2.314-2.316 2.316-6.062-.001-8.377-2.317-2.321-6.067-2.313-8.379-.002z"></path></svg>
              </div>   
              <span class="swymcs-share-button-text"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">${StorefrontLayoutContext?.Strings?.shareListCopyButtonCta}</font></font></span>
          </button>
          <button id="swymcs-confirm-share-list--facebook" class="swymcs-button swymcs-secondary-button swymcs-has-after-css" aria-label="Share List by facebook">
              <div class="swymcs-share-buttons-icon">
                <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"15\" viewBox=\"0 0 24 24\"><path fill=\"#000000\" d=\"M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z\"/></svg>
              </div>   
              <span class="swymcs-share-button-text">${StorefrontLayoutContext?.Strings?.shareListFacebookCta}</span>
          </button>
          <button id="swymcs-confirm-share-list--twitter" class="swymcs-button swymcs-secondary-button swymcs-has-after-css" aria-label="Share List by twitter">
              <div class="swymcs-share-buttons-icon">
                <svg xmlns=\"http://www.w3.org/2000/svg\"  viewBox=\"0 0 50 50\" height=\"15\"><path d=\"M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z\"/></svg>
              </div>   
              <span class="swymcs-share-button-text">${StorefrontLayoutContext?.Strings?.shareListTwitterCta}</span>
          </button>
        </div>
      </div>
    `
      this.attachEventListnerToShareList();
      this.generateSharedListURL();
  }

  attachEventListnerToShareList(){
    const swymShareCopyLinkButton = this.querySelector('#swym-custom-share-copy-link');
    const swymShareModal = this.querySelector('#swym-custom-share-form');
    const swymShareFacebookButton = this.querySelector('#swymcs-confirm-share-list--facebook');
    const swymShareTwitterButton = this.querySelector('#swymcs-confirm-share-list--twitter');
    
    swymShareCopyLinkButton.addEventListener('click', getShareCopyLink.bind(this));
    swymShareModal.addEventListener('submit', onShareWishlist.bind(this));
    swymShareFacebookButton.addEventListener('click', ()=>{
      shareListOnPlatform.call(this, "facebook")
    });
    swymShareTwitterButton.addEventListener('click', ()=>{
      shareListOnPlatform.call(this, "twitter")
    });

    
    
    function getShareCopyLink(){
      let listid = this.listId;
      const onSuccess = (link, lid) => {
        navigator.clipboard.writeText(link)
        .then(() => {
          this.closeDrawer();
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: 'Link Copied to Clipboard!',
            status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
            duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration
          });
        })
        .catch(err => {
          console.error('Failed to copy link to clipboard: ', err);
        });
      }
      let onError = (error) => {
          console.log("Error while generating the link", error)
      }
      _swat.generateSharedListURL(listid, onSuccess, onError);
    }
    
    function onShareWishlist(event){
      event.preventDefault();
      
      const shareFromName = this.querySelector("#swym-sender-name");
      const shareToEmail = this.querySelector("#swym-recepient-email");
      const shareMessage = this.querySelector("#swym-share-message");
      
      let listid = this.listId;
      let params = {
          toEmailId: shareToEmail.value,
          fromName: shareFromName.value,
          note: shareMessage.value,
          lid: listid || null,
          cprops: {}
      }
      
      _swat.sendListViaEmail(params, (response)=>{
          let receiver = params.toEmailId;
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: `Successfully shared wishlist with  ${receiver}`,
            status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
            duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration
          });
          this.closeDrawer();
        }, (error) => {
          window._swat?.utils.error('Error Sending Email', error);
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: `Error Sending Email`,
            status: StorefrontLayoutContext.NotificationStatusTypes?.Error,
            duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration
          });
      });
    }

    function shareListOnPlatform(platform) {
      const shareFromName = this.querySelector("#swym-sender-name");
      const shareToEmail = this.querySelector("#swym-recepient-email");
      const shareMessage = this.querySelector("#swym-share-message");
      
      const shareUrl = this.sharedLink;
      const note = shareMessage.value;
      const fromName = shareFromName.value;
      const onError = (error) => _swat.ui.uiRef.showErrorNotification({ message: error.description });
      let platformShareUrlTemplate = "";
      if (platform == "facebook")
        platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
      else if (platform == "twitter")
        platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`;
      _swat.shareListSocial(
        this.listId,
        fromName,
        platformShareUrlTemplate,
        platform,
        note,
        onError
      );
    }

    
  }

  async generateSharedListURL(){
    try{
       let sharedLink = await StorefrontLayoutAPI?.SwymWLAsyncApis?.generateSharedListURL(this.listId); 
        this.sharedLink = sharedLink;
    }catch(error){
      window._swat?.utils.error('Failed to generate Shared List URL', error);
    }
  }
  
  openDrawer() {
    this.elements.container.classList.add('swym-storefront-layout-show-action-view');
  }

  closeDrawer() {
    this.elements.container.classList.remove('swym-storefront-layout-show-action-view');
  }

}

class SwymStorefrontLayoutListOptions extends HTMLElement {
  constructor() {
    super();

    this.currentTarget = null;
    this.actionType = StorefrontLayoutContext.ActionTypes.ManageListItem;

    this.wishlistItem = null;
    this.collections = null;
    this.listId = null;
    this.list = null;
    this.renderUI();
    this.elements = {
      viewPortLayout: document.querySelector('.swym-storefront-layout-layout'),
      optionsContainer: this.querySelector('#swym-storefront-layout-list-action-options'),
      wishlistItemsContainer: document.querySelector('#swymcs-storefront-layout-items-container')
    }
  }

  renderUI() {
    this.innerHTML = `
    <div class="swym-storefront-layout-list-action-options-container">
      <div id="swym-storefront-layout-list-action-options"></div>
    </div>
    `
  }

  setData({ listId, list, item, selectedVariantId, collections, actionType = StorefrontLayoutContext.ActionTypes.ManageListItem }) {
    this.listId = listId;
    this.list = list;
    this.wishlistItem = item;
    this.collections = StorefrontLayoutContext.collections;
    this.currentSlectedVariantId = selectedVariantId;
    this.elements.wishlistItemsContainer = document.querySelector(`.swym-storefront-layout-items-container[data-lid="${listId}"]`)

    if(this.list?.listcontents?.length){
           this.renderMangeListOptions(); 
    }else{
      this.elements.optionsContainer.innerHTML = '';
    }
  }

  getSelectedVariant(item) {
    const selectedVariantId = this.currentSlectedVariantId || item.epi;
    return item.productData.variants.find((variant) => variant.id === selectedVariantId);
  }

  renderMangeListOptions(){

    this.elements.optionsContainer.innerHTML = `
      <div class="swym-storefront-layout-action-tooltip-btn add-all-to-cart-button">
        Add All to Cart
      </div>
      ${StorefrontLayoutContext.isShopperLoggedIn?`
        <div class="swym-storefront-layout-action-tooltip-btn share-collection-button">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" zoomAndPan="magnify" viewBox="0 0 810 809.999993" height="15" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="7e4f23c080"><path d="M 10 57 L 37 57 L 37 88 L 10 88 Z M 10 57 " clip-rule="nonzero"/></clipPath><clipPath id="f0bf5738b1"><path d="M 4.257812 78.171875 L 21.121094 51.5625 L 36.957031 61.601562 L 20.09375 88.207031 Z M 4.257812 78.171875 " clip-rule="nonzero"/></clipPath><clipPath id="cad3347930"><path d="M 4.257812 78.171875 L 21.121094 51.5625 L 36.957031 61.601562 L 20.09375 88.207031 Z M 4.257812 78.171875 " clip-rule="nonzero"/></clipPath><clipPath id="703ded2777"><path d="M 4.257812 78.171875 L 21.121094 51.5625 L 36.957031 61.601562 L 20.09375 88.207031 Z M 4.257812 78.171875 " clip-rule="nonzero"/></clipPath><clipPath id="18b80bf810"><path d="M 775 54 L 804 54 L 804 84 L 775 84 Z M 775 54 " clip-rule="nonzero"/></clipPath><clipPath id="5610856376"><path d="M 788.996094 47.660156 L 809.898438 71.226562 L 795.875 83.667969 L 774.96875 60.105469 Z M 788.996094 47.660156 " clip-rule="nonzero"/></clipPath><clipPath id="283afc34c8"><path d="M 788.996094 47.660156 L 809.898438 71.226562 L 795.875 83.667969 L 774.96875 60.105469 Z M 788.996094 47.660156 " clip-rule="nonzero"/></clipPath><clipPath id="9dc318ad8f"><path d="M 788.996094 47.660156 L 809.898438 71.226562 L 795.875 83.667969 L 774.96875 60.105469 Z M 788.996094 47.660156 " clip-rule="nonzero"/></clipPath><clipPath id="24526e189c"><path d="M 359 729 L 392 729 L 392 751 L 359 751 Z M 359 729 " clip-rule="nonzero"/></clipPath><clipPath id="298b44c2e0"><path d="M 387.671875 753.617188 L 356.785156 747.410156 L 360.480469 729.027344 L 391.363281 735.234375 Z M 387.671875 753.617188 " clip-rule="nonzero"/></clipPath><clipPath id="276291cc9b"><path d="M 387.671875 753.617188 L 356.785156 747.410156 L 360.480469 729.027344 L 391.363281 735.234375 Z M 387.671875 753.617188 " clip-rule="nonzero"/></clipPath><clipPath id="aaf1b6a732"><path d="M 387.671875 753.617188 L 356.785156 747.410156 L 360.480469 729.027344 L 391.363281 735.234375 Z M 387.671875 753.617188 " clip-rule="nonzero"/></clipPath></defs><path stroke-linecap="butt" transform="matrix(0.394423, -0.637911, 0.637911, 0.394423, 371.336586, 738.899407)" fill="none" stroke-linejoin="miter" d="M 0.00105762 11.002266 L 1052.924743 11.00123 " stroke="#000000" stroke-width="22" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(0.75, 0, 0, 0.75, 25.460929, 57.468574)" fill="none" stroke-linejoin="miter" d="M 0.0000109879 11.000235 L 1029.364646 11.000235 " stroke="#000000" stroke-width="22" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(0.520051, 0.540413, -0.540413, 0.520051, 24.633785, 70.180747)" fill="none" stroke-linejoin="miter" d="M -0.00061552 11.002625 L 524.537205 10.99804 " stroke="#000000" stroke-width="22" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(-0.14843, -0.735166, 0.735166, -0.14843, 361.511441, 739.154815)" fill="none" stroke-linejoin="miter" d="M -0.00161254 10.998851 L 516.904195 11.001341 " stroke="#000000" stroke-width="22" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(0.644943, -0.382817, 0.382817, 0.644943, 290.806777, 355.962278)" fill="none" stroke-linejoin="miter" d="M 0.000704853 11.003434 L 760.460818 11.003044 " stroke="#000000" stroke-width="22" stroke-opacity="1" stroke-miterlimit="4"/><g clip-path="url(#7e4f23c080)"><g clip-path="url(#f0bf5738b1)"><g clip-path="url(#cad3347930)"><g clip-path="url(#703ded2777)"><path fill="#000000" d="M 34.410156 59.996094 L 36.496094 61.316406 C 36.625 61.398438 36.703125 61.507812 36.738281 61.65625 C 36.769531 61.800781 36.746094 61.9375 36.664062 62.0625 L 20.386719 87.746094 C 20.308594 87.871094 20.195312 87.953125 20.050781 87.984375 C 19.902344 88.015625 19.769531 87.992188 19.640625 87.910156 L 17.554688 86.589844 C 16.679688 86.035156 15.863281 85.398438 15.113281 84.683594 C 14.359375 83.964844 13.683594 83.183594 13.085938 82.335938 C 12.488281 81.488281 11.976562 80.59375 11.554688 79.644531 C 11.132812 78.699219 10.808594 77.71875 10.578125 76.707031 C 10.351562 75.699219 10.222656 74.675781 10.195312 73.640625 C 10.167969 72.605469 10.242188 71.578125 10.417969 70.558594 C 10.59375 69.539062 10.867188 68.546875 11.238281 67.582031 C 11.609375 66.617188 12.074219 65.699219 12.625 64.828125 C 13.179688 63.953125 13.8125 63.144531 14.527344 62.394531 C 15.242188 61.648438 16.019531 60.976562 16.867188 60.382812 C 17.714844 59.789062 18.613281 59.28125 19.558594 58.867188 C 20.507812 58.449219 21.484375 58.128906 22.496094 57.902344 C 23.507812 57.679688 24.53125 57.554688 25.570312 57.53125 C 26.605469 57.511719 27.636719 57.589844 28.65625 57.765625 C 29.679688 57.945312 30.675781 58.222656 31.644531 58.597656 C 32.609375 58.972656 33.535156 59.4375 34.410156 59.996094 Z M 34.410156 59.996094 " fill-opacity="1" fill-rule="nonzero"/></g></g></g></g><g clip-path="url(#18b80bf810)"><g clip-path="url(#5610856376)"><g clip-path="url(#283afc34c8)"><g clip-path="url(#9dc318ad8f)"><path fill="#000000" d="M 798.125 81.664062 L 796.277344 83.304688 C 796.164062 83.402344 796.035156 83.449219 795.882812 83.441406 C 795.734375 83.433594 795.609375 83.371094 795.511719 83.257812 L 775.332031 60.515625 C 775.230469 60.402344 775.1875 60.273438 775.195312 60.125 C 775.207031 59.976562 775.265625 59.851562 775.378906 59.75 L 777.226562 58.113281 C 778.003906 57.421875 778.839844 56.816406 779.734375 56.292969 C 780.628906 55.765625 781.570312 55.332031 782.546875 54.992188 C 783.527344 54.652344 784.53125 54.410156 785.558594 54.265625 C 786.585938 54.121094 787.617188 54.082031 788.652344 54.140625 C 789.683594 54.199219 790.703125 54.359375 791.707031 54.621094 C 792.707031 54.878906 793.671875 55.234375 794.605469 55.6875 C 795.535156 56.136719 796.414062 56.671875 797.238281 57.296875 C 798.0625 57.921875 798.816406 58.621094 799.503906 59.394531 C 800.191406 60.167969 800.792969 61 801.316406 61.890625 C 801.835938 62.785156 802.265625 63.71875 802.601562 64.699219 C 802.9375 65.675781 803.175781 66.679688 803.316406 67.703125 C 803.453125 68.730469 803.492188 69.761719 803.425781 70.792969 C 803.363281 71.828125 803.199219 72.847656 802.933594 73.847656 C 802.667969 74.851562 802.308594 75.820312 801.855469 76.75 C 801.398438 77.683594 800.859375 78.5625 800.230469 79.390625 C 799.601562 80.21875 798.898438 80.976562 798.125 81.664062 Z M 798.125 81.664062 " fill-opacity="1" fill-rule="nonzero"/></g></g></g></g><g clip-path="url(#24526e189c)"><g clip-path="url(#298b44c2e0)"><g clip-path="url(#276291cc9b)"><g clip-path="url(#aaf1b6a732)"><path fill="#000000" d="M 359.894531 731.984375 L 360.378906 729.5625 C 360.410156 729.414062 360.484375 729.300781 360.609375 729.214844 C 360.734375 729.132812 360.871094 729.105469 361.015625 729.136719 L 390.828125 735.125 C 390.972656 735.152344 391.089844 735.230469 391.171875 735.355469 C 391.253906 735.480469 391.28125 735.617188 391.25 735.761719 L 390.761719 738.183594 C 390.558594 739.203125 390.257812 740.191406 389.859375 741.148438 C 389.460938 742.109375 388.972656 743.019531 388.394531 743.882812 C 387.820312 744.742188 387.164062 745.542969 386.429688 746.273438 C 385.699219 747.007812 384.902344 747.664062 384.039062 748.238281 C 383.179688 748.816406 382.269531 749.300781 381.3125 749.695312 C 380.355469 750.09375 379.371094 750.390625 378.355469 750.59375 C 377.34375 750.796875 376.320312 750.894531 375.285156 750.894531 C 374.25 750.894531 373.226562 750.789062 372.214844 750.585938 C 371.199219 750.382812 370.214844 750.082031 369.261719 749.683594 C 368.308594 749.285156 367.402344 748.796875 366.542969 748.21875 C 365.6875 747.644531 364.894531 746.988281 364.164062 746.25 C 363.433594 745.515625 362.785156 744.71875 362.210938 743.855469 C 361.640625 742.988281 361.15625 742.078125 360.765625 741.117188 C 360.371094 740.160156 360.074219 739.171875 359.875 738.152344 C 359.679688 737.132812 359.578125 736.105469 359.582031 735.066406 C 359.585938 734.027344 359.6875 733 359.894531 731.984375 Z M 359.894531 731.984375 " fill-opacity="1" fill-rule="nonzero"/></g></g></g></g></svg>
          ${StorefrontLayoutContext.Strings?.shareCollectionCta}
        </div>
      `:''}
      <div class="swym-storefront-layout-action-tooltip-btn delete-list-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
          <path d="M4.66667 14.5C4.30001 14.5 3.98612 14.3694 3.72501 14.1083C3.46389 13.8472 3.33334 13.5333 3.33334 13.1667V4.5H2.66667V3.16667H6.00001V2.5H10V3.16667H13.3333V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3333 14.5H4.66667ZM11.3333 4.5H4.66667V13.1667H11.3333V4.5ZM6.00001 11.8333H7.33334V5.83333H6.00001V11.8333ZM8.66667 11.8333H10V5.83333H8.66667V11.8333Z" fill="currentColor"/>
        </svg>
        ${StorefrontLayoutContext.Strings?.deleteListCta}
      </div>
    `
    
    this.addManageListOptionEventListeners();
  }

  addManageListOptionEventListeners() {
    const shareCollectionBtn = this.querySelector('.share-collection-button');
    const deleteListBtn = this.querySelector('.delete-list-button');
    const addAllToCartBtn = this.querySelector('.add-all-to-cart-button');
    
    addAllToCartBtn?.addEventListener('click', async () => {
      try {
        let itemsToAdd = this.list.listcontents.filter((item) =>
          {
            let isInCart = _swat.platform.isInDeviceCart(item.epi);
            return item.productData?.variants.find((variant) => variant.id === item.epi) && item.productData?.variants.find((variant) => variant.id === item.epi).available && !isInCart;
          }
        ).map((item) => {
          return {
            epi: item.epi,
            empi: item.empi,
            qty: 1
          }
        });
        if(itemsToAdd.length > 0){
            _swat.platform.addAllToCart(itemsToAdd, () => {
              console.log('swym addAllToCart success');
              (async () => {
                try {
                  const productsToRemove = itemsToAdd.map(({ epi, empi }) => {
                    const match = this.list.listcontents.find((li) => li.epi === epi && li.empi === empi);
                    return { epi, empi, du: match?.du };
                  });
                  await Promise.all(
                    productsToRemove.map((product) =>
                      StorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList(product, this.list.lid)
                    )
                  );
                  await StorefrontLayoutAPI?.SwymWLAsyncApis?.updateList();
                } catch (e) {
                  window._swat?.utils.warn('Failed to remove some items from wishlist after addAllToCart', e);
                }
              })();
              window._cartRefresh();
              document.querySelector('cart-drawer').open()
            },
            (error) => {
              StorefrontLayoutExtensions.Notification?.setMessage({
                message: 'Error adding items to cart',
                status: StorefrontLayoutContext.NotificationStatusTypes?.Error
              });
              console.log('swymaddAllToCart error', error);
            }
          );
        }else{
          StorefrontLayoutExtensions.Notification?.setMessage({
            message: 'No new items to add to cart. Items may already exist in your cart',
            status: StorefrontLayoutContext.NotificationStatusTypes?.Error
          });
        }
      } catch (error) {
        window._swat?.utils.error('swym Failed to add all to cart:', error);
      }
    });

    shareCollectionBtn?.addEventListener('click', () => {
      this.shareCollection();
    });

    deleteListBtn?.addEventListener('click', async () => {
      try {

        
        await StorefrontLayoutAPI?.SwymWLAsyncApis?.deleteLists([this.list]);
        await StorefrontLayoutExtensions.SwymStorefrontLayout?.refreshList();

        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutCollectionDeleted, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutCollectionInteractions });

      } catch (error) {
        window._swat?.utils.error('Failed to remove product from the list:', error);
      }
    });
  }

  async shareCollection() {
      StorefrontLayoutExtensions.SwymStorefrontLayoutActions?.setData({
        listId: this.list?.lid,
        list: this.list,
        collections: this.collections,
        actionType: StorefrontLayoutContext.ActionTypes.ShareList
      });
      StorefrontLayoutExtensions.SwymStorefrontLayoutActions?.openDrawer();
  }

}
  
/**
 * SwymStorefrontLayoutActionTooltip
 * 
 * This custom Web Component manages the action tooltip for storefront layout interactions.
 * It provides UI options for managing wishlist items, including adding to collections 
 * and removing from lists. The tooltip dynamically updates based on user actions 
 * and permissions.
 * 
 * Features:
 * - Displays options based on the selected wishlist item.
 * - Supports adding/removing items from collections or lists.
 * - Listens for user interactions and updates the UI accordingly.
 * - Ensures smooth integration with StorefrontLayoutContext.
 * 
 * Dependencies:
 * - StorefrontLayoutContext: Provides necessary context for actions and permissions.
 * - StorefrontLayoutAPI: Handles wishlist operations.
 * - StorefrontLayoutExtensions: Manages UI interactions like opening drawers.
 */
class SwymStorefrontLayoutActionTooltip extends HTMLElement {
  constructor() {
    super();

    this.isTooltipOpen = false;
    this.currentTarget = null;
    this.actionType = StorefrontLayoutContext.ActionTypes.ManageListItem;

    this.wishlistItem = null;
    this.collections = null;
    this.listId = null;
    this.list = null;
    this.renderUI();
    this.elements = {
      viewPortLayout: document.querySelector('.swym-storefront-layout-layout'),
      tooltipLayout: this.querySelector('.swym-storefront-layout-action-tooltip-layout'),
      optionsContainer: this.querySelector('#swym-storefront-layout-action-tooltip-options'),
      wishlistItemsContainer: document.querySelector('#swymcs-storefront-layout-items-container')
    }
    this.addEventListenerToView();
  }

  renderUI() {
    this.innerHTML = `
    <div class="swym-storefront-layout-action-tooltip-layout">
      <div id="swym-storefront-layout-action-tooltip-options"></div>
    </div>
    `
  }

  setData({ listId, list, item, selectedVariantId, collections, actionType = StorefrontLayoutContext.ActionTypes.ManageListItem }) {
    this.listId = listId;
    this.list = list;
    this.wishlistItem = item;
    this.collections = StorefrontLayoutContext.collections;
    this.currentSlectedVariantId = selectedVariantId;
    this.elements.wishlistItemsContainer = document.querySelector(`.swym-storefront-layout-items-container[data-lid="${listId}"]`)
    if (actionType === StorefrontLayoutContext.ActionTypes.ManageListItem) {
      this.renderWishlistItemOptions();
    }else if(actionType === StorefrontLayoutContext.ActionTypes.EditCollection){
      this.renderEditCollection();
    }else if(actionType === StorefrontLayoutContext.ActionTypes.SaveCollection){
      this.renderSaveCollection();
    }
  }

  getSelectedVariant(item) {
    const selectedVariantId = this.currentSlectedVariantId || item.epi;
    return item.productData.variants.find((variant) => variant.id === selectedVariantId);
  }

  async renderWishlistItemOptions() {
    if (this.wishlistItem && this.elements.optionsContainer) {
      const selectedVariant = this.getSelectedVariant(this.wishlistItem);
      const productImage = selectedVariant?.featured_image?.src || this.wishlistItem.productData?.featured_image || this.wishlistItem.iu;
      let canEdit = StorefrontLayoutContext.checkUserCanEditList(this.list);
      this.elements.optionsContainer.innerHTML = `
        ${StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection? `<div class="swym-storefront-layout-action-tooltip-btn add-to-collection-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M7.33331 8.66683H3.33331V7.3335H7.33331V3.3335H8.66665V7.3335H12.6666V8.66683H8.66665V12.6668H7.33331V8.66683Z" fill="currentColor"/>
          </svg>
          ${StorefrontLayoutContext.Strings?.addToCollectionCta}
        </div>` : ''}
        ${canEdit?`<div class="swym-storefront-layout-action-tooltip-btn remove-from-list-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M4.66669 14.5C4.30002 14.5 3.98613 14.3694 3.72502 14.1083C3.46391 13.8472 3.33335 13.5333 3.33335 13.1667V4.5H2.66669V3.16667H6.00002V2.5H10V3.16667H13.3334V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3334 14.5H4.66669ZM11.3334 4.5H4.66669V13.1667H11.3334V4.5ZM6.00002 11.8333H7.33335V5.83333H6.00002V11.8333ZM8.66669 11.8333H10V5.83333H8.66669V11.8333Z" fill="currentColor"></path>
          </svg>
          ${StorefrontLayoutContext.Strings?.removeItemCta}
        </div>`:''}
      `;
      this.addOptionEventListeners();
    }
  }

  addOptionEventListeners() {
    const addToCollectionBtn = this.querySelector('.add-to-collection-button');
    const removeFromListBtn = this.querySelector('.remove-from-list-button');

    addToCollectionBtn?.addEventListener('click', () => {
      this.closeTooltip();
      
      StorefrontLayoutExtensions.SwymStorefrontLayoutActions?.setData({
        listId: this.listId,
        list: this.list,
        item: this.wishlistItem,
        collections: this.collections,
        actionType: StorefrontLayoutContext.ActionTypes.AddToCollection
      });
      StorefrontLayoutExtensions.SwymStorefrontLayoutActions?.openDrawer();

    });

    removeFromListBtn?.addEventListener('click', async () => {
     
      try {

        this.closeTooltip();

        let { epi, empi, du } = this.wishlistItem;
        if(this.currentSlectedVariantId){
          epi = this.currentSlectedVariantId;
        }
        await StorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, this.listId);

        let elementDeleted = this.elements.wishlistItemsContainer?.querySelector(`[data-epi="${epi}"]`);
        elementDeleted?.remove();

        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutItemRemovedFromList, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutWishlistItemInteractions, epi, empi });

      } catch (error) {
        window._swat?.utils.error('Failed to remove product from the list:', error);
      }
    });
  }

  async renderEditCollection() {
    if (this.list && this.elements.optionsContainer) {
      this.elements.optionsContainer.innerHTML = `
        <div class="swym-storefront-layout-action-tooltip-btn share-collection-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <path d="M9.91666 12.8337C9.43055 12.8337 9.01735 12.6635 8.67707 12.3232C8.3368 11.983 8.16666 11.5698 8.16666 11.0837C8.16666 11.0253 8.18124 10.8892 8.21041 10.6753L4.11249 8.28366C3.95693 8.42949 3.77707 8.54373 3.57291 8.62637C3.36874 8.70901 3.14999 8.75033 2.91666 8.75033C2.43055 8.75033 2.01735 8.58019 1.67707 8.23991C1.3368 7.89963 1.16666 7.48644 1.16666 7.00033C1.16666 6.51421 1.3368 6.10102 1.67707 5.76074C2.01735 5.42046 2.43055 5.25033 2.91666 5.25033C3.14999 5.25033 3.36874 5.29164 3.57291 5.37428C3.77707 5.45692 3.95693 5.57116 4.11249 5.71699L8.21041 3.32533C8.19096 3.25727 8.17881 3.19164 8.17395 3.12845C8.16909 3.06526 8.16666 2.99477 8.16666 2.91699C8.16666 2.43088 8.3368 2.01769 8.67707 1.67741C9.01735 1.33713 9.43055 1.16699 9.91666 1.16699C10.4028 1.16699 10.816 1.33713 11.1562 1.67741C11.4965 2.01769 11.6667 2.43088 11.6667 2.91699C11.6667 3.4031 11.4965 3.8163 11.1562 4.15658C10.816 4.49685 10.4028 4.66699 9.91666 4.66699C9.68332 4.66699 9.46457 4.62567 9.26041 4.54303C9.05624 4.46039 8.87638 4.34616 8.72082 4.20033L4.62291 6.59199C4.64235 6.66005 4.6545 6.72567 4.65936 6.78887C4.66423 6.85206 4.66666 6.92255 4.66666 7.00033C4.66666 7.0781 4.66423 7.14859 4.65936 7.21178C4.6545 7.27498 4.64235 7.3406 4.62291 7.40866L8.72082 9.80033C8.87638 9.65449 9.05624 9.54026 9.26041 9.45762C9.46457 9.37498 9.68332 9.33366 9.91666 9.33366C10.4028 9.33366 10.816 9.5038 11.1562 9.84408C11.4965 10.1844 11.6667 10.5975 11.6667 11.0837C11.6667 11.5698 11.4965 11.983 11.1562 12.3232C10.816 12.6635 10.4028 12.8337 9.91666 12.8337ZM9.91666 11.667C10.0819 11.667 10.2205 11.6111 10.3323 11.4993C10.4441 11.3875 10.5 11.2489 10.5 11.0837C10.5 10.9184 10.4441 10.7798 10.3323 10.668C10.2205 10.5562 10.0819 10.5003 9.91666 10.5003C9.75138 10.5003 9.61284 10.5562 9.50103 10.668C9.38923 10.7798 9.33332 10.9184 9.33332 11.0837C9.33332 11.2489 9.38923 11.3875 9.50103 11.4993C9.61284 11.6111 9.75138 11.667 9.91666 11.667ZM2.91666 7.58366C3.08193 7.58366 3.22048 7.52776 3.33228 7.41595C3.44409 7.30415 3.49999 7.1656 3.49999 7.00033C3.49999 6.83505 3.44409 6.69651 3.33228 6.5847C3.22048 6.4729 3.08193 6.41699 2.91666 6.41699C2.75138 6.41699 2.61284 6.4729 2.50103 6.5847C2.38923 6.69651 2.33332 6.83505 2.33332 7.00033C2.33332 7.1656 2.38923 7.30415 2.50103 7.41595C2.61284 7.52776 2.75138 7.58366 2.91666 7.58366ZM9.91666 3.50033C10.0819 3.50033 10.2205 3.44442 10.3323 3.33262C10.4441 3.22081 10.5 3.08227 10.5 2.91699C10.5 2.75171 10.4441 2.61317 10.3323 2.50137C10.2205 2.38956 10.0819 2.33366 9.91666 2.33366C9.75138 2.33366 9.61284 2.38956 9.50103 2.50137C9.38923 2.61317 9.33332 2.75171 9.33332 2.91699C9.33332 3.08227 9.38923 3.22081 9.50103 3.33262C9.61284 3.44442 9.75138 3.50033 9.91666 3.50033Z" fill="currentColor" fill-opacity="0.8"/>
          </svg>
          ${StorefrontLayoutContext.Strings?.shareCollectionCta}
        </div>
        <div class="swym-storefront-layout-action-tooltip-btn delete-list-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M4.66667 14.5C4.30001 14.5 3.98612 14.3694 3.72501 14.1083C3.46389 13.8472 3.33334 13.5333 3.33334 13.1667V4.5H2.66667V3.16667H6.00001V2.5H10V3.16667H13.3333V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3333 14.5H4.66667ZM11.3333 4.5H4.66667V13.1667H11.3333V4.5ZM6.00001 11.8333H7.33334V5.83333H6.00001V11.8333ZM8.66667 11.8333H10V5.83333H8.66667V11.8333Z" fill="currentColor"/>
          </svg>
          ${StorefrontLayoutContext.Strings?.deleteCollectionCta}
        </div>
      `;
      this.addEditCollectionEventListeners();
    }
  }

  addEditCollectionEventListeners() {
    const shareCollectionBtn = this.querySelector('.share-collection-button');
    const deleteListBtn = this.querySelector('.delete-list-button');

    shareCollectionBtn?.addEventListener('click', () => {
      this.shareCollection();
    });

    deleteListBtn?.addEventListener('click', async () => {
      try {

        
        await StorefrontLayoutAPI?.SwymWLAsyncApis?.deleteLists([this.list]);
        this.closeTooltip();
        window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.List;
        await StorefrontLayoutExtensions.SwymStorefrontLayout?.refreshList();
        const collectionListView = document.querySelector('swym-storefront-layout-collection-list');
        collectionListView.closeCollectinListView();

        StorefrontLayoutExtensions.Notification?.setMessage({
          message: StorefrontLayoutContext.Strings?.notificationMessageCollectionDeleted,
          status: StorefrontLayoutContext.NotificationStatusTypes?.Toast,
          iconType: StorefrontLayoutContext.NotificationIconType?.SuccessIcon
        });

        window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutCollectionDeleted, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutCollectionInteractions });

      } catch (error) {
        window._swat?.utils.error('Failed to remove product from the list:', error);
      }
    });
  }

  async renderSaveCollection() {
    if (this.list && this.elements.optionsContainer) {
      this.elements.optionsContainer.innerHTML = `
        <div class="swym-storefront-layout-action-tooltip-btn save-collection-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 48 48" fill="none">
            <path d="M8 28H24" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 37H24" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 19H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 10H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M30 33H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M35 28L35 38" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${StorefrontLayoutContext.Strings?.saveCollectionCta}
        </div>
      `;
      this.addSaveCollectionEventListeners();
    }
  }

  addSaveCollectionEventListeners() {
    const saveCollectionBtn = this.querySelector('.save-collection-button');
    
    saveCollectionBtn?.addEventListener('click', () => {
      this.closeTooltip();
      this.handleSaveCollection();
    });
  }

  async shareCollection() {
    if (navigator.share) {
      try {
        let link = await StorefrontLayoutAPI?.SwymWLAsyncApis?.generateSharedListURL(this.list.lid);
        let shareUrl = `${window.location.origin}/${StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList}${this.list.lid}`;
        await navigator.share({
          title: StorefrontLayoutContext.Strings?.shareCollectionTitle,
          text: StorefrontLayoutContext.Strings?.shareCollectionMessage,
          url: shareUrl,
        });
      } catch (error) {
        window._swat?.utils.error('Failed to sharing content:', error);
      }
    } else {
      window._swat?.utils.warn('Your browser does not support the Web Share API.');
    }
  }
  
  async handleSaveCollection(){
    let savedList = await StorefrontLayoutAPI?.SwymWLAsyncApis?.createList(this.list.lname);
    let itemsToAdd = this.list.listcontents.map(({ empi, epi, du }) => ({ empi, epi, du }));
    // split the itemsToAdd into chunks of 10 and add them to the list
    const chunks = itemsToAdd.reduce((acc, item, index) => {
      const chunkIndex = Math.floor(index / 10);
      if(!acc[chunkIndex]){
        acc[chunkIndex] = [];
      }
      acc[chunkIndex].push(item);
      return acc;
    }, []);
    for(const chunk of chunks){
      await StorefrontLayoutAPI?.SwymWLAsyncApis?.addProductsToList(chunk, savedList.lid);
    }
    window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.List;
    
    StorefrontLayoutExtensions.Notification?.setMessage({
      message: StorefrontLayoutContext.Strings?.notificationMessageCollectionSaved,
      status: StorefrontLayoutContext.NotificationStatusTypes?.Neutral,
      iconType: StorefrontLayoutContext.NotificationIconType?.SuccessIcon,
      duration: StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationDuration,
      action: {
        label: StorefrontLayoutContext.Strings?.notificationActionViewCollection,
        onClick: () => {
          window.location.hash = StorefrontLayoutContext.StorefrontLayoutUrls?.CollectionList + savedList.lid;
        }
      }
    });

  }

  addEventListenerToView() {
    document.addEventListener("click", (event) => {
      if (!this.elements.tooltipLayout.contains(event.target)) {
        this.closeTooltip();
      }
    });
  }

  attachEventToHideTooltip(){

    window.removeEventListener("scroll", ()=> this.closeTooltip());
    window.addEventListener("scroll", ()=> this.closeTooltip());

    let scrollableElements = document.querySelectorAll('.swym-storefront-layout-scrollable');

    scrollableElements.forEach((element) => {
      element.removeEventListener("scroll", ()=> this.closeTooltip());
      element.addEventListener("scroll", ()=> this.closeTooltip());
    });
  }

  openTooltip() {
    this.isTooltipOpen = true;
    this.elements.tooltipLayout.classList.add('swym-storefront-layout-show-action-tooltip-view');
    this.attachEventToHideTooltip();
  }

  showOnTarget(buttonTarget){
    this.closeTooltip();

    let viewPort = document.querySelector('.swym-storefront-layout-layout');

    const tooltip = this.elements.tooltipLayout;
    let buttonRect = buttonTarget.getBoundingClientRect();
    let viewPortRect = viewPort?.getBoundingClientRect();

    const buttonRight = buttonRect.right;
    const buttonLeft = buttonRect.left;
    const buttonLeftOnViewPort = buttonRect.left - viewPortRect?.left;

    const tooltipWidth = this.elements.tooltipLayout.offsetWidth
    const viewportWidth = viewPort.clientWidth


    if (buttonLeftOnViewPort > viewportWidth / 2) {
      tooltip.style.left = `${(buttonLeft + 2) - tooltipWidth}px`
      tooltip.style.top = `${buttonRect.top + 25}px`
    } else {
      tooltip.style.left = `${buttonLeft + 2 }px`
      tooltip.style.top = `${buttonRect.top + 25}px`
    }

    setTimeout(()=>{
      this.openTooltip();
      this.currentTarget = buttonTarget;
    },100)

  }

  closeTooltip() {
    this.isTooltipOpen = false;
    this.elements.tooltipLayout.classList.remove('swym-storefront-layout-show-action-tooltip-view');
  }

}

/**
 * SwymStorefrontLayoutNotification
 * 
 * A Web Component for displaying notifications in the storefront layout. 
 * It supports customizable configurations, auto-hide functionality, 
 * and dynamic content rendering based on user actions.
 * 
 * Features:
 * - Supports various notification types (success, info, etc.).
 * - Configurable options for displaying images, titles, messages, and action buttons.
 * - Auto-hide functionality with configurable duration.
 * - Supports icons and images based on notification type.
 * - Integrates with `StorefrontLayoutContext.Settings` to check if notifications are enabled.
 * 
 * Dependencies:
 * - `StorefrontLayoutContext`: Provides settings and icon type references.
 * 
 * Usage:
 * ```html
 * <swym-storefront-layout-notification></swym-storefront-layout-notification>
 * ```
 * 
 * Example JavaScript Usage:
 * ```javascript
 * const notification = document.querySelector('swym-storefront-layout-notification');
 * notification.setMessage({
 *   message: 'Item added to wishlist!',
 *   status: 'success',
 *   duration: 4000,
 *   image: 'https://example.com/image.jpg',
 *   action: {
 *     label: 'View Wishlist',
 *     onClick: () => console.log('Wishlist opened')
 *   }
 * });
 * ```
 * 
 * Attributes:
 * - `status` (String) - Defines the notification status (e.g., `success`, `info`, `error`).
 * - `role` (String) - Defaults to `"alert"` for accessibility.
 * 
 * Methods:
 * - `setMessage(data, config)`: Sets notification content and displays it.
 * - `setNotificationConfig(config)`: Merges user-defined configuration with defaults.
 * - `renderUI()`: Updates the UI based on the provided notification data.
 * - `autoHide(duration)`: Automatically hides the notification after a specified duration.
 * - `showNotification()`: Displays the notification.
 * - `hideNotification()`: Hides the notification.
 * 
 * Events:
 * - `click` on `.swym-storefront-layout-notification-action` triggers the provided action callback.
 */
class SwymStorefrontLayoutNotification extends HTMLElement {
  constructor() {
    super();
    this.timeout = null;
    this.notificationData = null;
    this.defaultConfig = {
      showProgress: false,
      showImage: true,
      showActionButton: false,
      showMessage: true,
      showTitle: false
    };

    this.notificationConfig = this.defaultConfig;
  }

  connectedCallback() {
    this.setAttribute('role', this.getAttribute('role') || 'alert');
    this.setAttribute('status', this.getAttribute('status') || 'info');
  }

  setMessage(data, config = {}) {
    const {
      actionType, message, title, status = 'success', duration = 3000, action, image, product, icon, iconType
    } = data;
    
    this.notificationData = {
      actionType, message, status, duration, action, image, product, icon, iconType,
      title: title || product?.dt || null
    };
    
    if (StorefrontLayoutContext.Settings?.EnableStorefrontLayoutNotification) {
      this.setAttribute('status', status);
      this.setNotificationConfig(config);
      this.renderUI();
      this.autoHide(duration);
    }
  }

  setNotificationConfig(config) {
    this.notificationConfig = { ...this.defaultConfig, ...config };
  }

  renderUI() {
    if (!this.notificationData) return;
    
    const { message, image, iconType, title, action } = this.notificationData;
    const { showProgress, showImage, showActionButton, showMessage, showTitle } = this.notificationConfig;
    
    this.innerHTML = `
      ${showProgress ? '<div class="swym-storefront-layout-notification-progress-bar swym-storefront-notification-animated"></div>' : ''}
      <div class="swym-storefront-layout-notification-container">
        ${showImage && (image || iconType) ?`<div class="swym-storefront-layout-notification-image-container">
          ${ image ? `<img class="swym-storefront-layout-notification-image" src="${image}" alt="Notification Icon">` : ''}
          ${iconType ? this.getIconHtml(iconType) : ''}
        </div>`:''}
        <div class="swym-storefront-layout-notification-content">
          ${showTitle && title ? `<div class="swym-storefront-layout-notification-title">${title}</div>` : ''}
          ${showMessage && message ? `<div class="swym-storefront-layout-notification-message">${message}</div>` : ''}
        </div>
        ${showActionButton && action ? `<button class="swym-storefront-layout-notification-action">${action.label}</button>` : ''}
      </div>
    `;
    
    if (action) {
      this.querySelector('.swym-storefront-layout-notification-action')?.addEventListener('click', (event) => {
        this.hideNotification();
        action.onClick?.(event);
      });
    }
  }

  getIconHtml(iconType) {
    if (iconType === StorefrontLayoutContext.NotificationIconType?.SuccessIcon) {
      return `<svg viewBox="0 0 18 18" fill="none" class="swym-storefront-layout-notification-icon" aria-hidden="true">
        <path d="m12.053 5.429-.62.645-3.782 3.98-1.131-1.04-.654-.602-1.152 1.384.661.603 1.745 1.606.613.566 5.553-5.844-1.233-1.298Z" fill="currentColor"></path>
      </svg>`;
    }
    return '';
  }

  autoHide(duration) {
    clearTimeout(this.timeout);
    this.showNotification();
    this.timeout = setTimeout(() => this.hideNotification(), duration);
  }

  showNotification() {
    this.classList.add('visible');
  }

  hideNotification() {
    this.classList.remove('visible');
  }
}

/**
 * SwymStorefrontLayoutLoader Web Component
 *
 * This custom element is responsible for rendering different types of loading placeholders 
 * for the storefront layout. The type of loader is determined by the `loadertype` attribute.
 *
 * Supported loader types:
 * - WishlistListItem: Displays skeleton loaders for wishlist items.
 * - CollectionImages: Displays a placeholder for collection images.
 * - CarouselListItem: Displays skeleton loaders for carousel items.
 * - SpinnerLoader: Displays a rotating spinner for loading states.
 *
 * The component listens for attribute changes to control visibility (`loading`) 
 * and size (`width`, `height`).
 *
 * Usage:
 * <swym-storefront-layout-loader loadertype="WishlistListItem" loading="true"></swym-storefront-layout-loader>
 */
class SwymStorefrontLayoutLoader extends HTMLElement {
  constructor() {
    super();

    this.renderLoader();

  }

  renderLoader() {
    const loadertype = this.getAttribute('loadertype');

    const loaderListItemHtml = Array.from({ length: 3 })
    .map((_, i) => {
      return `
      <swym-storefront-layout-item class="swym-storefront-layout-loader">
        <div class="swym-storefront-layout-grid-item">
          <div class="swym-storefront-layout-grid-item-image-container">
            <div class="swym-storefront-layout-grid-item-image"></div>
          </div>
          <div class="swym-storefront-layout-grid-item-content">
            <div class="swym-storefront-layout-grid-item-title"></div>
            <div class="swym-storefront-layout-grid-item-price-variant">
            </div>
            <div class="swym-storefront-layout-grid-item-action-container">
              <button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart">
                Add To Cart
              </button>
            </div>
          </div>
        </div>
      </swym-storefront-layout-item>
    `;
    })
    .join("");

    if(loadertype === StorefrontLayoutContext.LoaderViewType.WishlistListItem){
      this.parentElement.innerHTML = `${loaderListItemHtml}`
    }else if(loadertype === StorefrontLayoutContext.LoaderViewType.CollectionImages){
      this.parentElement.innerHTML = `
        <div class="swym-storefront-layout-loader swym-storefront-layout-collection-list-images"></div>
      `
    }else if(loadertype === StorefrontLayoutContext.LoaderViewType.CarouselListItem){
      const loaderCollectionListHtml = Array.from({ length: 3 })
                .map((_, i) => {
                  return `
                  <div class="swym-storefront-layout-loader swym-storefront-layout-collection-grid-item">
                    <div class="swym-storefront-layout-collection-grid-item-image-container">
                      
                      <div class="swym-storefront-layout-collection-grid-item-primary-image ">
                        <div class="swym-storefront-layout-collection-grid-item-image"></div>
                      </div>
                    
                      <div class="swym-storefront-layout-collection-grid-item-secondary-image ">
                      <div class="swym-storefront-layout-collection-grid-item-image"></div>
                      </div>
                    
                      <div class="swym-storefront-layout-collection-grid-item-secondary-image ">
                        <div class="swym-storefront-layout-collection-grid-item-image"></div>
                      </div>
                    
                    </div>
                    <div class="swym-storefront-layout-collection-grid-item-info-container">
                      <div>
                        <div class="swym-storefront-layout-collection-grid-item-name"></div>
                        <div class="swym-storefront-layout-collection-grid-item-count"></div>
                      </div>
                      <div class="swym-storefront-layout-collection-grid-item-count"></div>
                    </div>
                    <div id="swym-storefront-layout-collection-grid-item-option-button" class="swym-storefront-layout-collection-grid-item-option-button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="none">
                        <circle cx="1.5" cy="1.50014" r="1.5" fill="#B1B7C3"></circle>
                        <circle cx="1.5" cy="6.50014" r="1.5" fill="#B1B7C3"></circle>
                        <circle cx="1.5" cy="11.5001" r="1.5" fill="#B1B7C3"></circle>
                      </svg>
                    </div>
                  </div>
                `;
                })
                .join("");

              this.parentElement.innerHTML = `${loaderCollectionListHtml}`
    }else if(loadertype === StorefrontLayoutContext.LoaderViewType.SpinnerLoader){
      this.innerHTML = `
      <div class="swym-storefront-layout-loader-container">
        <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
            <path fill="currentColor" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform 
            <animateTransform 
              <animateTransform 
                attributeName="transform" 
              attributeName="transform" 
                attributeName="transform" 
                attributeType="XML" 
              attributeType="XML" 
                attributeType="XML" 
                type="rotate"
                dur="1s" 
              dur="1s" 
                dur="1s" 
                from="0 50 50"
                to="360 50 50" 
              to="360 50 50" 
                to="360 50 50" 
                repeatCount="indefinite" />
          </path>
        </svg>
      </div>
      `;
    }
  }

  static get observedAttributes() {
    return ['loading', 'width', 'height'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'loading') {
      if (newValue === 'true') {
        this.style.display = 'flex';
      } else {
        this.style.display = 'none';
      }
    } else if (name == 'width') {
      this.style.width = newValue;
    } else if (name == 'height') {
      this.style.height = newValue;
    }
  }
}

/**
 * SwymStorefrontLayoutTitle Web Component
 *
 * This custom element is responsible for rendering the title section of the storefront layout, 
 * including the wishlist title and total item count.
 *
 * Functionality:
 * - Displays the wishlist title using `StorefrontLayoutContext.Strings?.title`.
 * - Shows the total count of wishlist items retrieved from `StorefrontLayoutContext.lists`.
 * - Listens for the `SwymWishlistFetched` event and updates the title dynamically when the wishlist is fetched.
 *
 * Usage:
 * <swym-storefront-layout-title></swym-storefront-layout-title>
 */
class SwymStorefrontLayoutTitle extends HTMLElement {
  constructor() {
    super();

    this.renderTitle();

    document.addEventListener(StorefrontLayoutContext.CustomEvents?.SwymWishlistFetched, () => {
      this.renderTitle();
    })
  }

  renderTitle() {
    const totalCount = StorefrontLayoutContext.lists?.reduce((total, list) => total + list.listcontents?.length, 0) || 0;
    this.innerHTML = `
    <div>
      <div class="swym-storefront-layout-title">
        ${StorefrontLayoutContext.Strings?.title} 
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none" class="${totalCount?'swym-storefront-heart-fill':'swym-storefront-heart-empty'}">
          <path d="M2.04363 2.00013C4.54368 -0.499876 7.71029 2.33346 8.54363 3.50012C9.21029 2.00012 12.5437 0.500119 14.5437 2.00013C18.6166 5.05486 12.5437 12.0001 8.54363 14.0001C4.04367 11.5001 -1.29179 5.3355 2.04363 2.00013Z" fill="currentColor" stroke="black"/>
        </svg>
      </div>
      ${ totalCount?`<div class="swym-storefront-layout-total-list-items-count" id="swym-storefront-layout-total-list-items-count">${totalCount} ${totalCount<=1? StorefrontLayoutContext.Strings?.item : StorefrontLayoutContext.Strings?.items }</div>`:''}
    </div>
    `;
  }

}

/**
 * SwymStorefrontLayoutLoggedUser Web Component
 *
 * This custom element handles user authentication UI within the storefront layout.
 *
 * Functionality:
 * - Checks if a user is logged in using `window.swymCustomerId`.
 * - Displays a login prompt if the user is not logged in (when `showLogin="true"`).
 * - Shows a welcome message with the user's name or email (when `showuser="true"`).
 * - Registers a callback in `window.SwymCallbacks` to update UI when Swym state changes.
 * - Tracks login button clicks via `StorefrontLayoutExtensions.InstrumentActionCodes`.
 *
 * Attributes:
 * - `showuser` (boolean): Determines whether to display logged-in user details.
 * - `showLogin` (boolean): Determines whether to display the login prompt.
 *
 * Usage:
 * <swym-storefront-layout-logged-user showuser="true" showLogin="true"></swym-storefront-layout-logged-user>
 */
class SwymStorefrontLayoutLoggedUser extends HTMLElement {
  constructor() {
    super();
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallbackFn.bind(this));
  }

  swymCallbackFn(swat) {
    const showUser = this.getAttribute('showuser') === 'true';
    const showLogin = this.getAttribute('showLogin') === 'true';
    let isUserLogged = !!window.swymCustomerId;

    if (!isUserLogged && showLogin) {
      this.renderLoginContainer();
    } else if (isUserLogged && showUser) {
      this.renderUserDetails();
    }

  }

  handleLoginButtonClick = (event) => {
    event.preventDefault();
    window._swat?.instrumentV3(StorefrontLayoutExtensions.InstrumentActionCodes.StorefrontLayoutUserLogIn, { "utm-term": StorefrontLayoutExtensions.InstrumentUtmTerms.StorefrontLayoutUiEngagement });
  };

  renderUserDetails() {
    let customer = StorefrontLayoutContext.SwymCustomerData;
    this.innerHTML = `
      <div class="swym-storefront-layout-logged-user-container">
        <div class="swym-storefront-layout-logged-user-welcome-message">${StorefrontLayoutContext.Strings?.loggedUserWelcomeMessage} <span class="swym-storefront-layout-logged-user-name">${customer?.name ? customer?.name : customer?.email}</span></div>
      </div>
    `
  }

  renderLoginContainer() {
      this.innerHTML = `
      <div class="swym-storefront-layout-login-user-container">
        <div class="swym-storefront-layout-login-content">
          <div class="swym-storefront-layout-login-heading">${StorefrontLayoutContext.Strings?.loginHeading}</div>
          <div class="swym-storefront-layout-login-description">${StorefrontLayoutContext.Strings?.loginText}</div>
        </div>
        <a href="${window.location.origin}/account" class="swym-storefront-layout-login-button" onClick={this.handleLoginButtonClick}>
          ${StorefrontLayoutContext.Strings?.loginButtonText}
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
            <path d="M13.8536 4.85368C14.0488 4.65841 14.0488 4.34183 13.8536 4.14657L10.6716 0.964589C10.4763 0.769327 10.1597 0.769327 9.96447 0.964589C9.7692 1.15985 9.7692 1.47643 9.96447 1.6717L12.7929 4.50012L9.96447 7.32855C9.7692 7.52381 9.7692 7.84039 9.96447 8.03566C10.1597 8.23092 10.4763 8.23092 10.6716 8.03566L13.8536 4.85368ZM0.5 5.00012L13.5 5.00012L13.5 4.00012L0.5 4.00012L0.5 5.00012Z" fill="currentColor"/>
          </svg>
        </a>
      </div>
    `
  }

}
  
customElements.define('swym-storefront-layout-as-modal', SwymStorefrontLayoutAsModal);
customElements.define('swym-storefront-layout-as-section', SwymStorefrontLayoutAsSection);
customElements.define('swym-storefront-layout-as-drawer', SwymStorefrontLayoutAsDrawer);
customElements.define('swym-storefront-layout-collection-carousel', SwymStorefrontLayoutCollectionCarousel);
customElements.define('swym-storefront-layout-item', SwymStorefrontLayoutWishlistItem);
customElements.define('swym-storefront-layout-default-wishlist', SwymStorefrontLayoutDefaultWishList);
customElements.define('swym-storefront-layout-collection-list', SwymStorefrontLayoutCollectionList);
customElements.define('swym-storefront-layout-actions', SwymStorefrontLayoutActions);
customElements.define('swym-storefront-layout-list-options', SwymStorefrontLayoutListOptions);
customElements.define('swym-storefront-layout-action-tooltip', SwymStorefrontLayoutActionTooltip);
customElements.define('swym-storefront-layout-notification', SwymStorefrontLayoutNotification);
customElements.define('swym-storefront-layout-loader', SwymStorefrontLayoutLoader);
customElements.define('swym-storefront-layout-login-user', SwymStorefrontLayoutLoggedUser);
customElements.define('swym-storefront-layout-title', SwymStorefrontLayoutTitle);
})();